export const evaluationTemplates = {
  BasicSpeaking: {
    label: "Basic Speaking",
    items: [
      {
        key: "relevance",
        label: "Độ phù hợp",
        items: [
          {
            key: "contentRelevance",
            label: "Sự liên quan về nội dung",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Học sinh không trả lời câu hỏi hoặc trả lời hoàn toàn không liên quan đến nội dung của câu hỏi.",
                score: 0,
              },
              {
                comment:
                  "Học sinh chỉ đưa ra một phần thông tin liên quan đến câu hỏi mà không đầy đủ.",
                score: 1,
              },
              { comment: "Học sinh trả lời đúng nội dung câu hỏi.", score: 2 },
            ],
          },
          {
            key: "answerStructure",
            label: "Cấu trúc câu trả lời",
            comment_auto: "",
            criterion_score: "",
            items: [
              { comment: "Học sinh không trả lời câu hỏi.", score: 0 },
              {
                comment:
                  "Học sinh có trả lời được câu hỏi nhưng chưa đưa ra được các ý bổ trợ.",
                score: 1,
              },
              {
                comment:
                  "Học sinh trả lời được câu hỏi, cùng với một vài ý bổ trợ cho câu trả lời.",
                score: 2,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "completeness",
        label: "Độ hoàn thiện",
        items: [
          {
            key: "informationAmount",
            label: "Lượng thông tin được đưa ra",
            comment_auto: "",
            criterion_score: "",
            items: [
              { comment: "Không có thông tin nào được cung cấp", score: 0 },
              {
                comment:
                  "Cung cấp được một phần thông tin, nhưng chưa đủ để trả lời được câu hỏi",
                score: 1,
              },
              {
                comment: "Cung cấp thông tin cần thiết đủ để trả lời câu hỏi",
                score: 2,
              },
            ],
          },
          {
            key: "vocabGrammarVariety",
            label: "Sự đa dạng của từ vựng và ngữ pháp",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment: "Không có từ vựng hay ngữ pháp nào được cung cấp",
                score: 0,
              },
              {
                comment: "Từ vựng và ngữ pháp còn lặp lại rất nhiều",
                score: 1,
              },
              {
                comment:
                  "Đã cố gắng sử dụng từ vựng và ngữ pháp đa dạng, tuy nhiên đôi khi chưa hiệu quả",
                score: 2,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "fluency",
        label: "Độ trôi chảy",
        items: [
          {
            key: "easeOfUnderstanding",
            label: "Khả năng nói liền mạch",
            comment_auto: "",
            criterion_score: "",
            items: [
              { comment: "Học sinh không nói được chút nào", score: 0 },
              {
                comment:
                  "Học sinh nói hầu như câu nào cũng vấp và thiếu liền mạch",
                score: 1,
              },
              {
                comment:
                  "Học sinh có thể nói liền mạch đa phần các câu, đôi khi có thể bị vấp hoặc ngập ngừng",
                score: 2,
              },
            ],
          },
          {
            key: "logicalArrangement",
            label: "Sự kết nối giữa các ý",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Học sinh không nói được gì nên không có sự kết nối giữa các ý",
                score: 0,
              },
              {
                comment:
                  "Học sinh có trả lời được, nhưng sự kết nối giữa các ý là rất ít.",
                score: 1,
              },
              {
                comment:
                  "Học sinh có thể hiện được sự kết nối giữa các ý tưởng, dù có thể chưa rõ ràng hoàn toàn.",
                score: 2,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "clarity",
        label: "Sự rõ ràng",
        items: [
          {
            key: "grammarAccuracy",
            label: "Mức độ dễ hiểu",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Học sinh không trả lời được hoặc câu trả lời không thể hiểu được",
                score: 0,
              },
              {
                comment:
                  "Học sinh trả lời có thể hiểu được, nhưng nhiều khi gây hiểu nhầm",
                score: 1,
              },
              {
                comment:
                  "Học sinh trả lời dễ hiểu và ít gặp trở ngại để hiểu được câu trả lời",
                score: 2,
              },
            ],
          },
          {
            key: "vocabAccuracy",
            label: "Khả năng sắp xếp logic",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Học sinh không trả lời được hoặc câu trả lời hoàn toàn không logic một chút nào",
                score: 0,
              },
              {
                comment:
                  "Học sinh trả lời với những lập luận chưa được logic, tuy nhiên vẫn có sự kết nối nhất định giữa các ý",
                score: 1,
              },
              {
                comment:
                  "Học sinh trả lời với lập luận khá logic, dễ hiểu, không tạo cảm giác vô lý cho người nghe",
                score: 2,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "accuracy",
        label: "Sự chính xác",
        items: [
          {
            key: "grammarAccuracy",
            label: "Độ chính xác về ngữ pháp",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Học sinh không trả lời được, hoặc sai ngữ pháp gây hoàn toàn không hiểu được bài nói",
                score: 0,
              },
              {
                comment:
                  "Học sinh mắc khá nhiều lỗi ngữ pháp ở mỗi câu, nhưng không ảnh hưởng nhiều đến khả năng hiểu.",
                score: 1,
              },
              {
                comment:
                  "Học sinh có thể nói nhiều câu không mắc lỗi ngữ pháp, chỉ mắc một lượng lỗi không đáng kể và không ảnh hưởng đến khả năng hiểu",
                score: 2,
              },
            ],
          },
          {
            key: "vocabAccuracy",
            label: "Độ chính xác về từ vựng",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Học sinh không trả lời được, hoặc sử dụng từ vựng sai hết",
                score: 0,
              },
              { comment: "Học sinh mắc nhiều lỗi về từ vựng", score: 1 },
              {
                comment:
                  "Học sinh có mắc một số lỗi về từ vựng nhưng không nhiều",
                score: 2,
              },
            ],
          },
        ],
        comment_detail: "",
      },
    ],
  },
  BasicWriting: {
    label: "Basic Writing",
    items: [
      {
        key: "relevance",
        label: "Độ phù hợp",
        items: [
          {
            key: "taskRelevance",
            label: "Mức độ bám sát đề bài",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Không trả lời câu hỏi hoặc nội dung hoàn toàn không liên quan",
                score: 0,
              },
              {
                comment:
                  "Có một vài chi tiết liên quan nhưng chưa đủ rõ ràng hoặc đi lạc hướng",
                score: 1,
              },
              {
                comment:
                  "Trả lời bám sát nội dung câu hỏi, thể hiện hiểu đúng đề",
                score: 2,
              },
            ],
          },
          {
            key: "taskAchievement",
            label: "Trả lời đúng yêu cầu bài viết",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Không có phản hồi phù hợp (chỉ lặp lại đề bài hoặc viết các câu không mang thông tin cần thiết)",
                score: 0,
              },
              {
                comment:
                  "Có câu trả lời nhưng còn rất sơ sài hoặc quá ngắn (ví dụ: chỉ 1 câu đơn, không rõ ràng)",
                score: 1,
              },
              {
                comment:
                  "Trả lời có nội dung rõ ràng, có thể chứa 1–3 câu đơn có thông tin cụ thể và liên quan.",
                score: 2,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "completeness",
        label: "Độ hoàn thiện",
        items: [
          {
            key: "informationAmount",
            label: "Lượng thông tin được đưa ra",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment: "Không có ý nào rõ ràng hoặc chỉ viết lại từ đề bài",
                score: 0,
              },
              {
                comment:
                  "Có đưa ra 1–2 ý nhưng còn thiếu thông tin để hiểu rõ câu trả lời",
                score: 1,
              },
              {
                comment: "Có ít nhất 2 ý cụ thể giúp làm rõ câu trả lời.",
                score: 2,
              },
            ],
          },
          {
            key: "lexicalAndGrammaticalVariety",
            label: "Sự đa dạng của từ vựng và ngữ pháp",
            comment_auto: "",
            criterion_score: "",
            items: [
              { comment: "Gần như không viết được 1 câu đầy đủ nào", score: 0 },
              {
                comment:
                  "Có viết được những câu đầy đủ khác nhau nhưng vẫn lặp lại từ vựng và cấu trúc",
                score: 1,
              },
              {
                comment:
                  "Có sử dụng từ/cấu trúc khác nhau nhưng còn giới hạn và nhiều lặp lại",
                score: 2,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "cohere",
        label: "Mạch lạc",
        items: [
          {
            key: "ideaOrganization",
            label: "Sự sắp xếp các ý trong đoạn",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Các câu rời rạc, không liên quan đến nhau (thể hiện dấu hiệu lạc đề) hoặc không có logic về thứ tự",
                score: 0,
              },
              {
                comment:
                  "Có một số ý được sắp xếp theo trình tự nhưng đôi khi còn gây nhầm lẫn hoặc chưa mạch lạc",
                score: 1,
              },
              {
                comment:
                  "Các câu được viết theo trình tự hợp lý, dễ theo dõi, thể hiện mạch ý đơn giản",
                score: 2,
              },
            ],
          },
          {
            key: "cohesionAndLinking",
            label: "Từ nối, sự liên kết giữa các câu",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Không có bất kỳ từ nối nào hoặc dùng sai khiến đoạn rối",
                score: 0,
              },
              {
                comment:
                  "Có sử dụng từ nối đơn giản (and, but, because...) nhưng chưa nhất quán hoặc chưa đúng",
                score: 1,
              },
              {
                comment: "Dùng từ nối phù hợp để liên kết các ý đơn giản. ",
                score: 2,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "clarity",
        label: "Sự rõ ràng",
        items: [
          {
            key: "grammarAccuracy",
            label: "Mức độ dễ hiểu",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment: "Câu viết không hiểu được hoặc gây hiểu sai hoàn toàn",
                score: 0,
              },
              {
                comment:
                  "Câu có thể hiểu được nhưng cần đoán ý, hoặc gây hiểu nhầm ở một số chỗ",
                score: 1,
              },
              {
                comment:
                  "Câu diễn đạt rõ ràng, dễ hiểu, người đọc không cần suy đoán nhiều để nắm được ý",
                score: 2,
              },
            ],
          },
          {
            key: "ideaExpression",
            label: "Diễn đạt ý",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Câu lủng củng, dùng từ sai ngữ cảnh khiến ý nghĩa không thể hiểu được",
                score: 0,
              },
              {
                comment:
                  "Câu có thể hiểu nhưng dùng từ chưa chính xác hoặc diễn đạt còn chung chung",
                score: 1,
              },
              {
                comment:
                  "Dùng từ đơn giản nhưng đúng ngữ cảnh, diễn đạt ý một cách hợp lý, dễ hình dung",
                score: 2,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "accuracy",
        label: "Sự chính xác",
        items: [
          {
            key: "grammarAccuracy",
            label: "Độ chính xác về ngữ pháp",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Tất cả các câu đều sai ngữ pháp, khiến người đọc không hiểu hoặc hiểu sai",
                score: 0,
              },
              {
                comment:
                  "Có nhiều lỗi ngữ pháp (chia thì, cấu trúc câu…) nhưng nhìn chung vẫn hiểu được ý",
                score: 1,
              },
              {
                comment:
                  "Phần lớn các câu đúng ngữ pháp đơn giản (S + V + O...), chỉ có vài lỗi nhỏ không ảnh hưởng đến việc hiểu",
                score: 2,
              },
            ],
          },
          {
            key: "vocabAccuracy",
            label: "Độ chính xác về từ vựng",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Dùng từ sai nghĩa, sai dạng từ hoặc không phù hợp với ngữ cảnh dẫn đến gây hiểu nhầm ý nghĩa cả bài",
                score: 0,
              },
              {
                comment:
                  "Có nhiều lỗi dùng từ nhưng ý nghĩa chung vẫn nắm được",
                score: 1,
              },
              {
                comment:
                  "Từ vựng đơn giản nhưng phù hợp ngữ cảnh, đúng nghĩa, ít lỗi",
                score: 2,
              },
            ],
          },
        ],
        comment_detail: "",
      },
    ],
  },
  PiSpeaking: {
    label: "PI Speaking",
    items: [
      {
        key: "relevance",
        label: "Độ phù hợp",
        items: [
          {
            key: "contentRelevance",
            label: "Sự liên quan về nội dung",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Học sinh không trả lời câu hỏi hoặc trả lời hoàn toàn không liên quan đến nội dung của câu hỏi.",
                score: 0,
              },
              {
                comment:
                  "Học sinh chỉ đưa ra một phần thông tin liên quan đến câu hỏi mà không đầy đủ",
                score: 1,
              },
              { comment: "Học sinh trả lời đúng nội dung câu hỏi", score: 2 },
            ],
          },
          {
            key: "answerStructure",
            label: "Cấu trúc câu trả lời",
            comment_auto: "",
            criterion_score: "",
            items: [
              { comment: "Học sinh không trả lời câu hỏi.", score: 0 },
              {
                comment:
                  "Học sinh có trả lời được câu hỏi nhưng chỉ đưa ra được khá ít các ý bổ trợ",
                score: 1,
              },
              {
                comment:
                  "Học sinh trả lời được câu hỏi, cùng với đầy đủ các ý bổ trợ cho câu trả lời.",
                score: 2,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "completeness",
        label: "Độ hoàn thiện",
        items: [
          {
            key: "informationProvided",
            label: "Lượng thông tin được đưa ra",
            comment_auto: "",
            criterion_score: "",
            items: [
              { comment: "Không có thông tin nào được cung cấp", score: 0 },
              {
                comment:
                  "Cung cấp được một phần thông tin, nhưng chưa đủ để trả lời được câu hỏi",
                score: 1,
              },
              {
                comment: "Cung cấp thông tin cần thiết đủ để trả lời câu hỏi",
                score: 2,
              },
            ],
          },
          {
            key: "lexicalAndGrammaticalVariety",
            label: "Sự đa dạng của từ vựng và ngữ pháp",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment: "Không có từ vựng hay ngữ pháp nào được cung cấp",
                score: 0,
              },
              {
                comment:
                  "Từ vựng và ngữ pháp còn lặp lại rất nhiều, hoặc có cố gắng sử dụng đa dạng nhưng chưa hiệu quả",
                score: 1,
              },
              {
                comment:
                  "Sử dụng từ vựng và ngữ pháp khá đa dạng và tương đối hiệu quả, nhưng vẫn còn nhiều lỗi khi sử dụng",
                score: 2,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "fluency",
        label: "Độ trôi chảy",
        items: [
          {
            key: "speechFluency",
            label: "Khả năng nói liền mạch",
            comment_auto: "",
            criterion_score: "",
            items: [
              { comment: "Học sinh không nói được chút nào", score: 0 },
              {
                comment:
                  "Học sinh nói hầu như câu nào cũng vấp và thiếu liền mạch",
                score: 1,
              },
              {
                comment:
                  "Học sinh có thể nói liền mạch đa phần các câu, đôi khi có thể bị vấp hoặc ngập ngừng",
                score: 2,
              },
            ],
          },
          {
            key: "ideaConnection",
            label: "Sự kết nối giữa các ý",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Học sinh không nói được gì nên không có sự kết nối giữa các ý",
                score: 0,
              },
              {
                comment:
                  "Học sinh có thể hiện được sự kết nối giữa các ý tưởng, dù có thể chưa rõ ràng hoàn toàn.",
                score: 1,
              },
              {
                comment:
                  "Học sinh trả lời với các ý được liên kết với nhau tương đối rõ ràng.",
                score: 2,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "clarity",
        label: "Sự rõ ràng",
        items: [
          {
            key: "comprehensibility",
            label: "Mức độ dễ hiểu",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Học sinh không trả lời được hoặc câu trả lời không thể hiểu được",
                score: 0,
              },
              {
                comment:
                  "Học sinh trả lời có thể hiểu được, nhưng nhiều khi gây hiểu nhầm",
                score: 1,
              },
              {
                comment:
                  "Học sinh trả lời dễ hiểu và ít gặp trở ngại để hiểu được câu trả lời",
                score: 2,
              },
            ],
          },
          {
            key: "logicalOrganization",
            label: "Khả năng sắp xếp logic",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Học sinh không trả lời được hoặc câu trả lời hoàn toàn không logic một chút nào",
                score: 0,
              },
              {
                comment:
                  "Học sinh trả lời với những lập luận chưa được logic, tuy nhiên vẫn có sự kết nối nhất định giữa các ý",
                score: 1,
              },
              {
                comment:
                  "Học sinh trả lời với lập luận khá logic, dễ hiểu, không tạo cảm giác vô lý cho người nghe",
                score: 2,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "accuracy",
        label: "Sự chính xác",
        items: [
          {
            key: "grammarAccuracy",
            label: "Độ chính xác về ngữ pháp",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Học sinh không trả lời được, hoặc sai ngữ pháp gây hoàn toàn không hiểu được bài nói",
                score: 0,
              },
              {
                comment:
                  "Học sinh mắc khá nhiều lỗi ngữ pháp ở mỗi câu, nhưng không ảnh hưởng nhiều đến khả năng hiểu.",
                score: 1,
              },
              {
                comment:
                  "Học sinh có thể nói nhiều câu không mắc lỗi ngữ pháp, chỉ mắc một lượng lỗi không đáng kể và không ảnh hưởng đến khả năng hiểu",
                score: 2,
              },
            ],
          },
          {
            key: "vocabularyAccuracy",
            label: "Độ chính xác về từ vựng",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Học sinh không trả lời được, hoặc sử dụng từ vựng sai hết",
                score: 0,
              },
              { comment: "Học sinh mắc nhiều lỗi về từ vựng", score: 1 },
              {
                comment:
                  "Học sinh có mắc một số lỗi về từ vựng nhưng không nhiều",
                score: 2,
              },
            ],
          },
        ],
        comment_detail: "",
      },
    ],
  },
  PiWriting: {
    label: "PI Writing",
    items: [
      {
        key: "relevance",
        label: "Độ phù hợp",
        items: [
          {
            key: "taskRelevance",
            label: "Mức độ bám sát đề bài",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Không trả lời đúng yêu cầu của đề, nội dung hoàn toàn không liên quan",
                score: 0,
              },
              {
                comment:
                  "Có một vài chi tiết liên quan đến đề nhưng chưa rõ ràng hoặc có chỗ lạc đề",
                score: 1,
              },
              {
                comment:
                  "Trả lời đúng trọng tâm, nội dung bám sát đề bài, thể hiện hiểu rõ yêu cầu chủ đề",
                score: 2,
              },
            ],
          },
          {
            key: "taskAchievement",
            label: "Trả lời đúng yêu cầu bài viết",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Chỉ sao chép từ đề bài, viết các câu đơn không liên kết hoặc thông tin không cần thiết",
                score: 0,
              },
              {
                comment:
                  "Viết được một đoạn ngắn nhưng thông tin còn rời rạc, chưa bao phủ toàn bộ yêu cầu hoặc thiếu chiều sâu",
                score: 1,
              },
              {
                comment:
                  "Viết được đoạn văn đơn giản (4–6 câu hoặc hơn), thông tin rõ ràng, có sự bao quát phần lớn yêu cầu của đề bài",
                score: 2,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "completeness",
        label: "Độ hoàn thiện",
        items: [
          {
            key: "informationProvided",
            label: "Lượng thông tin được đưa ra",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Chỉ viết lại đề bài hoặc viết vài từ/câu rất ngắn không chứa thông tin cụ thể",
                score: 0,
              },
              {
                comment:
                  "Đoạn có từ 2–3 câu mang ý nghĩa rõ ràng nhưng còn thiếu thông tin bổ trợ hoặc mô tả chưa đầy đủ",
                score: 1,
              },
              {
                comment:
                  "Đoạn có khoảng 4–6 câu tối thiểu, trình bày được ít nhất 2 ý chính cùng với lý do, ví dụ hoặc mô tả bổ sung đơn giản",
                score: 2,
              },
            ],
          },
          {
            key: "lexicalAndGrammaticalVariety",
            label: "Sự đa dạng của từ vựng và ngữ pháp",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Gần như chỉ lặp lại một vài từ và cấu trúc rất đơn giản.",
                score: 0,
              },
              {
                comment:
                  "Có sử dụng được một vài cấu trúc và từ vựng khác nhau, nhưng lặp lại đáng kể và thiếu linh hoạt.",
                score: 1,
              },
              {
                comment:
                  "Cố gắng sử dụng một số từ/cụm từ và cấu trúc câu khác nhau để làm phong phú nội dung, dù đôi lúc chưa chính xác",
                score: 2,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "cohere",
        label: "Mạch lạc",
        items: [
          {
            key: "ideaOrganization",
            label: "Sự sắp xếp các ý trong đoạn",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Các câu rời rạc, không liên quan đến nhau hoặc thứ tự ý gây nhầm lẫn, khiến người đọc khó theo dõi",
                score: 0,
              },
              {
                comment:
                  "Có tổ chức nhất định, các ý sắp xếp tương đối hợp lý nhưng chưa mượt hoặc đôi chỗ thiếu rõ ràng",
                score: 1,
              },
              {
                comment:
                  "Các ý được sắp xếp hợp lý, logic, dễ hiểu và mạch lạc",
                score: 2,
              },
            ],
          },
          {
            key: "cohesionAndLinking",
            label: "Từ nối, sự liên kết giữa các câu",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Không có từ nối hoặc dùng từ nối sai gây cản trở mạch văn",
                score: 0,
              },
              {
                comment:
                  "Sử dụng từ nối cơ bản (and, but, because, then...) nhưng còn lặp lại hoặc dùng chưa đúng chỗ",
                score: 1,
              },
              {
                comment:
                  "Dùng đa dạng và hợp lý các từ nối để kết nối các câu và ý",
                score: 2,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "clarity",
        label: "Sự rõ ràng",
        items: [
          {
            key: "grammarAccuracy",
            label: "Mức độ dễ hiểu",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Câu văn lủng củng hoặc sai ngữ pháp đến mức gây hiểu sai hoặc không thể hiểu",
                score: 0,
              },
              {
                comment:
                  "Câu văn có thể hiểu được nhưng một số phần gây lúng túng hoặc phải đoán ý",
                score: 1,
              },
              {
                comment:
                  "Hầu hết các câu đều dễ hiểu, diễn đạt rõ ràng, người đọc nắm được nội dung mà không cần suy đoán.",
                score: 2,
              },
            ],
          },
          {
            key: "ideaExpression",
            label: "Diễn đạt ý",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Câu diễn đạt không đúng ngữ cảnh, từ dùng sai hoặc diễn đạt mơ hồ khiến câu mất ý nghĩa",
                score: 0,
              },
              {
                comment:
                  "Câu có ý nhưng diễn đạt còn chung chung hoặc dùng từ chưa thật phù hợp",
                score: 1,
              },
              {
                comment:
                  "Câu diễn đạt mạch lạc, sử dụng từ đơn giản nhưng đúng ngữ cảnh và giúp hình dung rõ ràng nội dung",
                score: 2,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "accuracy",
        label: "Độ chính xác",
        items: [
          {
            key: "grammarAccuracy",
            label: "Độ chính xác về ngữ pháp",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Hầu hết các câu sai ngữ pháp nghiêm trọng (chia thì sai, sai cấu trúc, câu không hoàn chỉnh), gây hiểu sai",
                score: 0,
              },
              {
                comment:
                  "Có nhiều lỗi ngữ pháp (thiếu chủ ngữ, động từ, sai thì...) nhưng người đọc vẫn hiểu được phần lớn nội dung",
                score: 1,
              },
              {
                comment:
                  "Câu đơn và câu ghép đơn giản phần lớn đúng ngữ pháp, chỉ mắc lỗi nhỏ không ảnh hưởng đến khả năng hiểu",
                score: 2,
              },
            ],
          },
          {
            key: "vocabularyAccuracy",
            label: "Độ chính xác về từ vựng",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Dùng từ sai nghĩa, sai dạng, hoặc không phù hợp khiến câu bị hiểu sai hoặc mất nghĩa",
                score: 0,
              },
              {
                comment:
                  "Có một số lỗi dùng từ (sai collocation, dùng từ sai tình huống) nhưng không ảnh hưởng nghiêm trọng đến hiểu ý",
                score: 1,
              },
              {
                comment:
                  "Từ vựng phù hợp ngữ cảnh, dùng đúng từ/cụm từ thông dụng, có thể đơn giản nhưng rõ nghĩa",
                score: 2,
              },
            ],
          },
        ],
        comment_detail: "",
      },
    ],
  },
  FoundationSpeaking: {
    label: "Foundation Speaking",
    items: [
      {
        key: "fluencyAndCoherence",
        label: "Độ phù hợp",
        items: [
          {
            key: "continuousSpeakingAbility",
            label: "Khả năng nói liên tục",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Nói ngắt quãng thường xuyên, không thể hiện ý tưởng được một cách liên tục",
                score: 0.5,
              },
              {
                comment:
                  "Có thể nói liên tục nhưng vẫn gặp khó khăn, ngắt quãng hoặc do dự nhiều",
                score: 1.5,
              },
              {
                comment:
                  "Nói tương đối liên tục, ít ngắt quãng, nhưng chưa thực sự trôi chảy",
                score: 2.5,
              },
            ],
          },
          {
            key: "abilityArrangeIdeas",
            label: "Khả năng sắp xếp ý tưởng",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Ý tưởng rời rạc, không có sự liên kết hoặc không rõ ràng",
                score: 0.5,
              },
              {
                comment:
                  "Ý tưởng có sự liên kết nhưng đôi khi còn lộn xộn hoặc khó hiểu",
                score: 1.5,
              },
              {
                comment:
                  "Ý tưởng được sắp xếp mạch lạc, dễ hiểu nhưng vẫn còn đơn giản",
                score: 2.5,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "lexicalResource",
        label: "Độ hoàn thiện",
        items: [
          {
            key: "informationProvided",
            label: "Sự đa dạng từ vựng",
            comment_auto: "",
            criterion_score: "",
            items: [
              { comment: "Sử dụng từ vựng hạn chế, lặp lại nhiều", score: 0.5 },
              {
                comment:
                  "Sử dụng từ vựng cơ bản, nhưng có thể thiếu sự đa dạng và một số lỗi",
                score: 1.5,
              },
              {
                comment:
                  "Sử dụng từ vựng đa dạng, phù hợp với chủ đề, nhưng chưa phong phú",
                score: 2.5,
              },
            ],
          },
          {
            key: "lexicalAndGrammaticalVariety",
            label: "Sự chính xác và phù hợp",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Từ vựng không chính xác hoặc không phù hợp với ngữ cảnh",
                score: 0.5,
              },
              {
                comment:
                  "Từ vựng sử dụng khá chính xác, phù hợp với ngữ cảnh, nhưng đôi khi còn mắc lỗi nhỏ",
                score: 1.5,
              },
              {
                comment:
                  "Từ vựng chính xác, phù hợp với ngữ cảnh và chủ đề, nhưng vẫn có thể còn một số lỗi nhỏ",
                score: 2.5,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "Pronunciation",
        label: "Phát âm",
        items: [
          {
            key: "clarityAccuracy",
            label: "Sự rõ ràng và chính xác",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment: "Phát âm không rõ ràng, khó nghe, mắc nhiều lỗi",
                score: 0.5,
              },
              {
                comment:
                  "Phát âm tương đối rõ ràng, nhưng vẫn còn một số lỗi phát âm",
                score: 1.5,
              },
              {
                comment:
                  "Phát âm rõ ràng, dễ hiểu, nhưng có thể chưa đạt đến mức hoàn hảo",
                score: 2.5,
              },
            ],
          },
          {
            key: "abilityIntonationNegative",
            label: "Khả năng sử dụng ngữ điệu và trọng âm",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment: "Ngữ điệu đơn điệu, trọng âm không chính xác",
                score: 0.5,
              },
              {
                comment:
                  "Sử dụng ngữ điệu và trọng âm cơ bản, nhưng đôi khi chưa tự nhiên",
                score: 1.5,
              },
              {
                comment:
                  "Ngữ điệu và trọng âm sử dụng khá tự nhiên, nhưng vẫn còn đơn giản hoặc chưa nhất quán",
                score: 2.5,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "grammaticalRangeAccuracy",
        label: "Ngữ pháp và độ chính xác",
        items: [
          {
            key: "abilityVarietyOfStructures",
            label: "Khả năng sử dụng đa dạng cấu trúc",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment: "Cấu trúc câu rất đơn giản, lặp lại, không đa dạng",
                score: 0.5,
              },
              {
                comment:
                  "Sử dụng một số cấu trúc ngữ pháp đa dạng, nhưng còn hạn chế",
                score: 1.5,
              },
              {
                comment:
                  "Sử dụng đa dạng cấu trúc ngữ pháp, nhưng vẫn còn thiếu phức tạp",
                score: 2.5,
              },
            ],
          },
          {
            key: "accuracy",
            label: "Sự chính xác",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Nhiều lỗi ngữ pháp ảnh hưởng đến khả năng hiểu câu trả lời",
                score: 0.5,
              },
              {
                comment:
                  "Một số lỗi ngữ pháp nhỏ nhưng không ảnh hưởng lớn đến khả năng hiểu câu trả lời",
                score: 1.5,
              },
              {
                comment:
                  "Ngữ pháp chính xác với một số lỗi nhỏ, nhưng không ảnh hưởng đến khả năng hiểu câu trả lời",
                score: 2.5,
              },
            ],
          },
        ],
        comment_detail: "",
      },
    ],
  },
  FoundationWriting: {
    label: "Foundation Writing",
    items: [
      {
        key: "taskAchievement",
        label: "Trả lời đúng yêu cầu bài viết",
        items: [
          {
            key: "levelSatisfactionMeetings",
            label: "Mức độ đáp ứng yêu cầu",
            comment_auto: "",
            criterion_score: "",
            items: [
              { comment: "Không thể hiện được gì", score: 0.5 },
              {
                comment: "Trả lời được một phần câu hỏi, nhưng chưa đầy đủ",
                score: 1.5,
              },
              {
                comment:
                  "Hoàn toàn đáp ứng yêu cầu câu hỏi, nhưng có thể chưa xuất sắc",
                score: 2.5,
              },
            ],
          },
          {
            key: "clarityPersuasion",
            label: "Tính rõ ràng và sự thuyết phục",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment: "Ý tưởng mơ hồ, không rõ ràng hoặc thiếu thuyết phục",
                score: 0.5,
              },
              {
                comment:
                  "Ý tưởng cơ bản rõ ràng, nhưng thiếu thuyết phục hoặc hỗ trợ cụ thể",
                score: 1.5,
              },
              {
                comment:
                  "Ý tưởng rõ ràng, có tính thuyết phục, được hỗ trợ bởi ví dụ, lập luận cụ thể",
                score: 2.5,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "lexicalResource",
        label: "Độ hoàn thiện",
        items: [
          {
            key: "informationProvided",
            label: "Sự đa dạng từ vựng",
            comment_auto: "",
            criterion_score: "",
            items: [
              { comment: "Sử dụng từ vựng hạn chế, lặp lại nhiều", score: 0.5 },
              {
                comment: "Từ vựng ở mức cơ bản, có một số lỗi lặp từ",
                score: 1.5,
              },
              {
                comment:
                  "Sử dụng từ vựng đa dạng, tránh lặp từ, nhưng chưa phong phú",
                score: 2.5,
              },
            ],
          },
          {
            key: "lexicalAndGrammaticalVariety",
            label: "Sự chính xác và phù hợp",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Từ vựng không chính xác hoặc không phù hợp với ngữ cảnh",
                score: 0.5,
              },
              {
                comment: "Sử dụng từ vựng phù hợp với một số lỗi nhỏ",
                score: 1.5,
              },
              {
                comment: "Từ vựng chính xác, phù hợp với ngữ cảnh và chủ đề",
                score: 2.5,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "coherenceCohesion",
        label: "Sự gắn kết",
        items: [
          {
            key: "abilityArrangeIdeas",
            label: "Khả năng sắp xếp các ý tưởng",
            comment_auto: "",
            criterion_score: "",
            items: [
              { comment: "Ý tưởng sắp xếp lộn xộn, không rõ ràng", score: 0.5 },
              {
                comment: "Ý tưởng sắp xếp hợp lý nhưng có thể chưa mạch lạc",
                score: 1.5,
              },
              {
                comment:
                  "Ý tưởng được sắp xếp mạch lạc và có sự logic nhất định",
                score: 2.5,
              },
            ],
          },
          {
            key: "abilityWords",
            label: "Khả năng sử dụng từ nối",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment: "Ít hoặc không sử dụng từ nối, câu rời rạc",
                score: 0.5,
              },
              {
                comment: "Sử dụng từ nối cơ bản nhưng chưa linh hoạt",
                score: 1.5,
              },
              {
                comment:
                  "Sử dụng từ nối hiệu quả để liên kết các ý tưởng, dù chưa đa dạng",
                score: 2.5,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "grammaticalRangeAccuracy",
        label: "Ngữ pháp và độ chính xác",
        items: [
          {
            key: "diversity",
            label: "Sự đa dạng",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment: "Sử dụng rất hạn chế các cấu trúc ngữ pháp",
                score: 0.5,
              },
              {
                comment: "Sử dụng một số cấu trúc cơ bản, nhưng thiếu đa dạng",
                score: 1.5,
              },
              {
                comment:
                  "Sử dụng đa dạng các cấu trúc ngữ pháp, dù còn đơn giản",
                score: 2.5,
              },
            ],
          },
          {
            key: "accuracy",
            label: "Sự chính xác",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "Lỗi ngữ pháp nhiều, ảnh hưởng đến khả năng hiểu bài viết",
                score: 0.5,
              },
              {
                comment:
                  "Một số lỗi ngữ pháp nhưng không ảnh hưởng nhiều đến khả năng hiểu bài viết",
                score: 1.5,
              },
              {
                comment:
                  "Ngữ pháp tương đối chính xác, nhưng còn mắc một số lỗi nhỏ",
                score: 2.5,
              },
            ],
          },
        ],
        comment_detail: "",
      },
    ],
  },
  IEHighSpeaking: {
    label: "IE High Speaking",
    items: [
      {
        key: "fluencyCoherence",
        label: "Fluency and coherence",
        items: [
          {
            key: "breakHesitate",
            label: "",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment: "Học viên không tham gia Test",
                eComment: "• Essentially none.\n• Speech is totally incoherent.",
                score: 1,
              },
              {
                comment:
                  "Học viên chưa thể giao tiếp và truyền đạt được ý tưởng. <br/>" +
                  "Ngôn ngữ chưa thể đánh giá được",
                eComment: "• Lengthy pauses before nearly every word.\n• Isolated words may be recognisable but speech is of virtually no communicative significance.",
                score: 2,
              },
              {
                comment:
                  "Khi trình bày, có các khoảng dừng dài trước hầu hết các từ <br/>" +
                  "Khả năng truyền đạt ý tưởng cần cải thiện thêm",
                eComment: "• Frequent, sometimes long, pauses occur while candidate searches for words.\n• Limited ability to link simple sentences and go beyond simple responses to questions.\n• Frequently unable to convey basic message.",
                score: 3,
              },
              {
                comment:
                  "Khi học viên trình bày còn có những khoảng dừng dài <br/>" +
                  "Khả năng liên kết các câu đơn còn hạn chế <br/>" +
                  "Chỉ đưa ra được những câu trả lời đơn giản và thường không truyền tải được thông điệp cơ bản",
                eComment: "• Unable to keep going without noticeable pauses.\n• Speech may be slow with frequent repetition.\n• Often self-corrects.\n• Can link simple sentences but often with repetitious use of connectives.\n• Some breakdowns in coherence.",
                score: 4,
              },
              {
                comment:
                  "Trong lúc trả lời vẫn có những khoảng dừng đáng chú ý, tốc độ nói của học viên khá chậm, thường xuyên bị lặp và tự sửa lỗi <br/>" +
                  "Học viên có thể liên kết được các câu cơ bản nhưng còn sử dụng lặp đi lặp lại các phép liên kết đơn giản, tính mạch lạc vẫn còn bị gián đoạn.",
                eComment: "• Usually able to keep going, but relies on repetition and self-correction to do so and/or on slow speech.\n• Hesitations are often associated with mid-sentence searches for fairly basic lexis and grammar.\n• Overuse of certain discourse markers, connectives and other cohesive features.\n• More complex speech usually causes disfluency but simpler language may be produced fluently.",
                score: 5,
              },
              {
                comment:
                  "Học viên thường xuyên duy trì được độ trôi chảy của lời nói nhưng phải lặp lại, tự sửa lỗi và nói chậm để có thể nói liên tục. <br/>" +
                  "Học viên có thể lạm dụng (sử dụng quá mức) một số từ nối, phép nối và discourse markers <br/>" +
                  "Tạo ra được những lời nói đơn giản và lưu loát, nhưng việc truyền đạt bị phức tạp hơn nên gây ra các vấn đề về độ trôi chảy",
                eComment: "• Able to keep going and demonstrates a willingness to produce long turns.\n• Coherence may be lost at times as a result of hesitation, repetition and/or self-correction.\n• Uses a range of spoken discourse markers, connectives and cohesive features though not always appropriately.",
                score: 6,
              },
              {
                comment:
                  "Học viên có thể mở rộng câu trả lời, mặc dù đôi khi có thể mất độ mạch lạc do thỉnh thoảng lặp lại, tự sửa lỗi hoặc do ngập ngừng <br/>" +
                  "Sử dụng nhiều các phép nối và discourse markers nhưng không phải lúc nào cũng thích hợp",
                eComment: "• Able to keep going and readily produce long turns without noticeable effort.\n• Some hesitation, repetition and/or self-correction may occur, often mid-sentence and indicate problems with accessing appropriate language. However, these will not affect coherence.\n• Flexible use of spoken discourse markers, connectives and cohesive features.",
                score: 7,
              },
              {
                comment:
                  "Học viên có thể mở rộng, kéo dài câu nói mà không cần nỗ lực nhiều hoặc mất tính mạch lạc <br />" +
                  "Đôi khi có thể thể hiện sự ngập ngừng liên quan đến ngôn ngữ hoặc một số sự lặp lại và / hoặc tự điều chỉnh, sửa lỗi <br />" +
                  "Sử dụng nhiều, đa dạng và linh hoạt các phép nối nối cũng như discourse markers",
                eComment: "• Fluent with only very occasional repetition or self-correction.\n• Hesitation may occasionally be used to find words or grammar, but most will be content related.\n• Topic development is coherent, appropriate and relevant.",
                score: 8,
              },
              {
                comment:
                  "Học viên duy trì bài nói một cách trôi chảy, chỉ thỉnh thoảng lặp từ hoặc tự sửa lỗi hay ngập ngừng do tìm nội dung, ý diễn đạt chứ hiếm khi phải dừng để tìm từ ngữ<br/>" +
                  "Phát triển các chủ đề một cách mạch lạc và phù hợp",
                eComment: "• Fluent with only very occasional repetition or self-correction.\n• Any hesitation that occurs is used only to prepare the content of the next utterance and not to find words or grammar.\n• Speech is situationally appropriate and cohesive features are fully acceptable.\n• Topic development is fully coherent and appropriately extended.",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "lexicalResource",
        label: "Lexical resource",
        items: [
          {
            key: "Sự đa dạng từ vựng",
            label: "",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "- Hầu như không có vốn từ ngoài một vài từ rời rạc. \n- Không thể giao tiếp được.",
                eComment: "• No resource bar a few isolated words.\n• No communication possible.",
                score: 1,
              },
              {
                comment:
                  "- Vốn từ rất hạn chế. Chỉ nói được các từ rời rạc hoặc câu học thuộc. \n- Khó giao tiếp nếu không có cử chỉ hỗ trợ.",
                eComment: "• Very limited resource. Utterances consist of isolated words or memorised utterances.\n• Little communication possible without the support of mime or gesture.",
                score: 2,
              },
              {
                comment:
                  "- Vốn từ hạn chế, chủ yếu là từ đơn giản để diễn đạt thông tin cá nhân. \n- Không đủ từ vựng cho chủ đề lạ.",
                eComment: "• Resource limited to simple vocabulary used primarily to convey personal information.\n• Vocabulary inadequate for unfamiliar topics.",
                score: 3,
              },
              {
                comment:
                  "- Vốn từ đủ cho chủ đề quen thuộc nhưng chỉ diễn đạt được ý cơ bản với chủ đề lạ. \n- Thường xuyên sai từ. \n- Hiếm khi paraphrase.",
                eComment: "• Resource sufficient for familiar topics but only basic meaning can be conveyed on unfamiliar topics.\n• Frequent inappropriacies and errors in word choice.\n• Rarely attempts paraphrase.",
                score: 4,
              },
              {
                comment:
                  "- Có đủ từ vựng để nói về nhiều chủ đề nhưng thiếu linh hoạt. \n- Có cố gắng paraphrase nhưng chưa hiệu quả.",
                eComment: "• Resource sufficient to discuss familiar and unfamiliar topics but there is limited flexibility.\n• Attempts paraphrase but not always with success.",
                score: 5,
              },
              {
                comment:
                  "- Đủ vốn từ để phát triển ý. \n- Có thể dùng từ chưa chính xác nhưng vẫn hiểu được. \n- Nhìn chung paraphrase khá tốt.",
                eComment: "• Resource sufficient to discuss topics at length.\n• Vocabulary use may be inappropriate but meaning is clear.\n• Generally able to paraphrase successfully.",
                score: 6,
              },
              {
                comment:
                  "- Sử dụng từ vựng linh hoạt cho nhiều chủ đề. \n- Có khả năng dùng từ ít phổ biến và thành ngữ, nhận biết collocation và văn phong, dù còn lỗi. \n- Paraphrase hiệu quả.",
                eComment: "• Resource flexibly used to discuss a variety of topics.\n• Some ability to use less common and idiomatic items and an awareness of style and collocation is evident though inappropriacies occur.\n• Effective use of paraphrase as required.",
                score: 7,
              },
              {
                comment:
                  "- Vốn từ phong phú, sử dụng linh hoạt để diễn đạt chính xác.\n- Dùng tốt từ ít phổ biến và thành ngữ dù đôi khi còn lỗi nhỏ. \n- Paraphrase hiệu quả.",
                eComment: "• Wide resource, readily and flexibly used to discuss all topics and convey precise meaning.\n• Skilful use of less common and idiomatic items despite occasional inaccuracies in word choice and collocation.\n• Effective use of paraphrase as required.",
                score: 8,
              },
              {
                comment:
                  "- Sử dụng từ hoàn toàn linh hoạt và chính xác trong mọi ngữ cảnh. \n- Duy trì ngôn ngữ tự nhiên và giàu tính thành ngữ.",
                eComment: "• Total flexibility and precise use in all contexts.\n• Sustained use of accurate and idiomatic language.",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "grammaticalRangeAccuracy",
        label: "Grammatical Range & Accuracy",
        items: [
          {
            key: "grammarAccuracy",
            label: "",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "- Không có ngôn ngữ đáng chấm điểm trừ khi là học thuộc.",
                eComment: "• No rateable language unless memorised.",
                score: 1,
              },
              {
                comment:
                  "- Không có bằng chứng về việc sử dụng các dạng câu cơ bản.",
                eComment: "• No evidence of basic sentence forms.",
                score: 2,
              },
              {
                comment:
                  "- Có cố gắng dùng câu cơ bản nhưng mắc rất nhiều lỗi ngữ pháp, trừ các câu học thuộc.",
                eComment: "• Basic sentence forms are attempted but grammatical errors are numerous except in apparently memorised utterances.",
                score: 3,
              },
              {
                comment:
                  "- Có thể tạo câu cơ bản, một số câu ngắn không lỗi. \n- Mệnh đề phụ hiếm, cấu trúc lặp lại và lỗi xảy ra thường xuyên.",
                eComment: "• Can produce basic sentence forms and some short utterances are error-free.\n• Subordinate clauses are rare and, overall, turns are short, structures are repetitive and errors are frequent.",
                score: 4,
              },
              {
                comment:
                  "- Câu cơ bản tương đối chính xác.\n- Có cố dùng cấu trúc phức nhưng hạn chế, thường sai và đôi khi phải diễn đạt lại.",
                eComment: "• Basic sentence forms are fairly well controlled for accuracy.\n• Complex structures are attempted but these are limited in range, nearly always contain errors and may lead to the need for reformulation.",
                score: 5,
              },
              {
                comment:
                  "- Kết hợp câu ngắn và câu phức với nhiều cấu trúc nhưng chưa linh hoạt. \n- Lỗi thường xảy ra ở câu phức nhưng hiếm khi gây khó hiểu.",
                eComment: "• Produces a mix of short and complex sentence forms and a variety of structures with limited flexibility.\n• Though errors frequently occur in complex structures, these rarely impede communication.",
                score: 6,
              },
              {
                comment:
                  "- Sử dụng đa dạng cấu trúc một cách linh hoạt.\n- Nhiều câu không lỗi. Dùng hiệu quả cả câu đơn và câu phức dù vẫn còn một số lỗi cơ bản.",
                eComment: "• A range of structures flexibly used. Error-free sentences are frequent.\n• Both simple and complex sentences are used effectively despite some errors. A few basic errors persist.",
                score: 7,
              },
              {
                comment:
                  "- Phạm vi cấu trúc rộng, dùng linh hoạt.\n- Phần lớn câu không lỗi. \n- Thỉnh thoảng có lỗi nhỏ không hệ thống. Một vài lỗi cơ bản có thể vẫn còn.",
                eComment: "• Wide range of structures, flexibly used.\n• The majority of sentences are error free.\n• Occasional inappropriacies and non-systematic errors occur. A few basic errors may persist.",
                score: 8,
              },
              {
                comment:
                  "- Cấu trúc luôn chính xác tuyệt đối, ngoại trừ những lỗi nhỏ kiểu người bản xứ.",
                eComment: "• Structures are precise and accurate at all times, apart from ‘mistakes’ characteristic of native speaker speech.",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "pronunciation",
        label: "Pronunciation",
        items: [
          {
            key: "pronunciationAbility",
            label: "",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "- Có thể phát âm được một số từ đơn lẻ và âm vị riêng biệt, nhưng không truyền tải được ý nghĩa tổng thể. \n- Không thể hiểu được.",
                eComment: "• Can produce occasional individual words and phonemes that are recognisable, but no overall meaning is conveyed.\n• Unintelligible.",
                score: 1,
              },
              {
                comment:
                  "- Sử dụng rất ít đặc điểm ngữ âm chấp nhận được (có thể do bài nói quá ngắn). \n- Gặp khó khăn lớn khi nói liên tục. \n- Phần lớn từ và âm bị phát âm sai, truyền tải rất ít ý nghĩa. \n- Thường không thể hiểu được.",
                eComment: "• Uses few acceptable phonological features (possibly because sample is insufficient).\n• Overall problems with delivery impair attempts at connected speech.\n• Individual words and phonemes are mainly mispronounced and little meaning is conveyed.\n• Often unintelligible.",
                score: 2,
              },
              {
                comment:
                  "- Thể hiện một số đặc điểm của band 2 và một vài (nhưng không phải tất cả) đặc điểm tích cực của band 4.",
                eComment: "• Displays some features of band 2, and some, but not all, of the positive features of band 4.",
                score: 3,
              },
              {
                comment:
                  "- Sử dụng một số đặc điểm ngữ âm chấp nhận được, nhưng phạm vi hạn chế.\n- Có thể phát âm đủ chính xác nhưng có sự gián đoạn thường xuyên về nhịp điệu tổng thể. \n- Cố gắng sử dụng ngữ điệu và trọng âm nhưng kiểm soát còn hạn chế. Từ hoặc âm riêng lẻ thường xuyên phát âm sai, gây thiếu rõ ràng. \n- Người nghe cần nỗ lực để hiểu và có những đoạn không thể hiểu được.",
                eComment: "• Uses some acceptable phonological features, but the range is limited.\n• Produces some acceptable chunking, but there are frequent lapses in overall rhythm.\n• Attempts to use intonation and stress, but control is limited.\n• Individual words or phonemes are frequently mispronounced, causing lack of clarity.\n• Understanding requires some effort and there may be patches of speech that cannot be understood.",
                score: 4,
              },
              {
                comment:
                  "- Thể hiện tất cả các đặc điểm tích cực của band 4 và một số (nhưng không phải tất cả) đặc điểm tích cực của band 6.",
                eComment: "• Displays all the positive features of band 4, and some, but not all, of the positive features of band 6.",
                score: 5,
              },
              {
                comment:
                  "- Sử dụng được nhiều đặc điểm ngữ âm nhưng khả năng kiểm soát chưa ổn định. \n- Ngắt nhịp nhìn chung phù hợp, nhưng nhịp điệu có thể bị ảnh hưởng do thiếu trọng âm hoặc nói quá nhanh. \n- Có sử dụng hiệu quả ngữ điệu và trọng âm nhưng không duy trì ổn định.\n- Một số từ hoặc âm phát âm sai nhưng chỉ thỉnh thoảng gây thiếu rõ ràng. \n- Có thể được hiểu trong toàn bộ bài nói, dù đôi lúc người nghe phải cố gắng.",
                eComment: "• Uses a range of phonological features, but control is variable.\n• Chunking is generally appropriate, but rhythm may be affected by a lack of stress-timing and/or a rapid speech rate.\n• Some effective use of intonation and stress, but this is not sustained.\n• Individual words or phonemes may be mispronounced but this causes only occasional lack of clarity.\n• Can generally be understood throughout without much effort.",
                score: 6,
              },
              {
                comment:
                  "- Thể hiện tất cả các đặc điểm tích cực của band 6 và một số (nhưng không phải tất cả) đặc điểm tích cực của band 8.",
                eComment: "• Displays all the positive features of band 6, and some, but not all, of the positive features of band 8.",
                score: 7,
              },
              {
                comment:
                  "- Sử dụng đa dạng các đặc điểm ngữ âm để truyền tải ý nghĩa chính xác và/hoặc tinh tế. \n- Duy trì nhịp điệu phù hợp. \n- Linh hoạt trong việc sử dụng trọng âm và ngữ điệu trong các câu dài, dù đôi lúc có lỗi nhỏ. \n- Có thể dễ dàng được hiểu xuyên suốt. \n- Giọng địa phương hầu như không ảnh hưởng đến khả năng hiểu.",
                eComment: "• Uses a wide range of phonological features to convey precise and/or subtle meaning.\n• Can sustain appropriate rhythm. Flexible use of stress and intonation across long utterances, despite occasional lapses.\n• Can be easily understood throughout.\n• Accent has minimal effect on intelligibility.",
                score: 8,
              },
              {
                comment:
                  "- Sử dụng đầy đủ các đặc điểm ngữ âm để truyền tải ý nghĩa chính xác và/hoặc tinh tế. \n- Duy trì linh hoạt các đặc điểm của lời nói nối âm trong suốt bài. \n- Có thể được hiểu một cách dễ dàng hoàn toàn.\n- Giọng địa phương không ảnh hưởng đến khả năng hiểu.",
                eComment: "• Uses a full range of phonological features to convey precise and/or subtle meaning.\n• Flexible use of features of connected speech is sustained throughout.\n• Can be effortlessly understood throughout.\n• Accent has no effect on intelligibility.",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
    ],
  },
  IESpeakingEntrance: {
    label: "IE High Speaking Entrance",
    items: [
      {
        key: "fluencyCoherence",
        label: "Fluency and coherence",
        items: [
          {
            key: "breakHesitate",
            label: "Sự do dự khi nói",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                eComment: "• Essentially none.\n• Speech is totally incoherent.",
                comment:
                  "Học viên không thể giao tiếp và truyền đạt<br/>" +
                  "Bài nói hoàn toàn rời rạc",
                score: 1,
              },
              {
                eComment: "• Lengthy pauses before nearly every word.\n• Isolated words may be recognisable but speech is of virtually no communicative significance.",
                comment:
                  "Khi trình bày, có các khoảng dừng dài trước hầu hết các từ<br/>" +
                  "Học viên có thể nói các từ đơn nhưng khả năng truyền đạt thấp, hầu như không có ý nghĩa giao tiếp",
                score: 2,
              },
              {
                eComment: "• Frequent, sometimes long, pauses occur while candidate searches for words.\n• Limited ability to link simple sentences and go beyond simple responses to questions.\n• Frequently unable to convey basic message.",
                comment:
                  "Khi học viên trình bày còn có những khoảng dừng dài và thường xuyên để tìm từ vựng<br/>" +
                  "Khả năng liên kết các câu đơn còn hạn chế<br/>" +
                  "Chỉ đưa ra được những câu trả lời đơn giản và thường không truyền tải được thông điệp cơ bản",
                score: 3,
              },
              {
                eComment: "• Unable to keep going without noticeable pauses.\n• Speech may be slow with frequent repetition.\n• Often self-corrects.\n• Can link simple sentences but often with repetitious use of connectives.\n• Some breakdowns in coherence.",
                comment:
                  "Trong lúc trả lời vẫn có những khoảng dừng đáng chú ý, tốc độ nói của học viên khá chậm, thường xuyên bị lặp và tự sửa lỗi<br/>" +
                  "Học viên có thể liên kết được các câu cơ bản nhưng còn sử dụng lặp đi lặp lại các phép liên kết đơn giản, tính mạch lạc vẫn còn bị gián đoạn.",
                score: 4,
              },
              {
                eComment: "• Usually able to keep going, but relies on repetition and self-correction to do so and/or on slow speech.\n• Hesitations are often associated with mid-sentence searches for fairly basic lexis and grammar.\n• Overuse of certain discourse markers, connectives and other cohesive features.\n• More complex speech usually causes disfluency but simpler language may be produced fluently.",
                comment:
                  "Học viên thường xuyên duy trì được độ trôi chảy của lời nói nhưng phải lặp lại, tự sửa lỗi và nói chậm để có thể nói liên tục<br/>" +
                  "Học viên thường ngập ngừng để tìm kiếm những từ vựng và ngữ pháp khá căn bản<br/>" +
                  "Học viên có thể lạm dụng (sử dụng quá mức) một số từ nối, phép nối và cụm từ nối<br/>" +
                  "Học viên tạo ra được những lời nói đơn giản và lưu loát, nhưng việc truyền đạt bị phức tạp hơn nên gây ra các vấn đề về độ trôi chảy",
                score: 5,
              },
              {
                eComment: "• Able to keep going and demonstrates a willingness to produce long turns.\n• Coherence may be lost at times as a result of hesitation, repetition and/or self-correction.\n• Uses a range of spoken discourse markers, connectives and cohesive features though not always appropriately.",
                comment:
                  "Học viên có thể mở rộng câu trả lời, mặc dù đôi khi có thể mất độ mạch lạc do thỉnh thoảng lặp lại, tự sửa lỗi hoặc do ngập ngừng<br/>" +
                  "Sử dụng nhiều các phép nối và cụm từ nối nhưng không phải lúc nào cũng thích hợp",
                score: 6,
              },
              {
                eComment: "• Able to keep going and readily produce long turns without noticeable effort.\n• Some hesitation, repetition and/or self-correction may occur, often mid-sentence and indicate problems with accessing appropriate language. However, these will not affect coherence.\n• Flexible use of spoken discourse markers, connectives and cohesive features.",
                comment:
                  "Học viên có thể mở rộng, kéo dài câu nói mà không cần nỗ lực nhiều hoặc mất tính mạch lạc<br/>" +
                  "Đôi khi có thể thể hiện sự ngập ngừng, một số sự lặp lại và / hoặc tự điều chỉnh, sửa lỗi ở giữa câu nói, liên quan đến việc tìm kiếm ngôn ngữ phù hợp nhưng không ảnh hưởng đến độ mạch lạc<br/>" +
                  "Sử dụng nhiều, đa dạng và linh hoạt các phép nối cũng như cụm từ nối",
                score: 7,
              },
              {
                eComment: "• Fluent with only very occasional repetition or self-correction.\n• Hesitation may occasionally be used to find words or grammar, but most will be content related.\n• Topic development is coherent, appropriate and relevant.",
                comment:
                  "Học viên duy trì bài nói một cách trôi chảy, chỉ thỉnh thoảng lặp từ hoặc tự sửa lỗi hay ngập ngừng do tìm nội dung, ý diễn đạt chứ hiếm khi phải dừng để tìm từ ngữ hay ngữ pháp<br/>" +
                  "Phát triển các chủ đề một cách mạch lạc và phù hợp",
                score: 8,
              },
              {
                eComment: "• Fluent with only very occasional repetition or self-correction.\n• Any hesitation that occurs is used only to prepare the content of the next utterance and not to find words or grammar.\n• Speech is situationally appropriate and cohesive features are fully acceptable.\n• Topic development is fully coherent and appropriately extended.",
                comment:
                  "Học viên nói trôi chảy và hiếm khi lặp lại hay tự điều chỉnh, sửa lỗi<br/>" +
                  "Mọi sự do dự, ngập ngừng trong lúc nói đều liên quan đến nội dung, không phải là tìm từ hoặc ngữ pháp<br/>" +
                  "Học viên nói mạch lạc, phù hợp với ngữ cảnh, sử dụng các đặc trưng liên kết một cách hoàn toàn thích hợp<br/>" +
                  "Phát triển các chủ đề một cách mạch lạc, đầy đủ và hợp lý",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "lexicalResource",
        label: "Lexical resource",
        items: [
          {
            key: "Sự đa dạng từ vựng",
            label: "Sự đa dạng từ vựng",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                eComment: "• No resource bar a few isolated words.\n• No communication possible.",
                comment:
                  "Học viên không có vốn từ vựng hoặc chỉ biết ít từ đơn<br/>" +
                  "Học viên không có sự giao tiếp",
                score: 1,
              },
              {
                eComment: "• Very limited resource. Utterances consist of isolated words or memorised utterances.\n• Little communication possible without the support of mime or gesture.",
                comment:
                  "Học viên có rất ít vốn từ vựng. Học viên chỉ nói được những từ đơn, riêng biệt hoặc những câu nói được ghi nhớ<br/>" +
                  "Hầu như không thể giao tiếp nếu không dùng biểu cảm gương mặt hay ngôn ngữ cơ thể",
                score: 2,
              },
              {
                eComment: "• Resource limited to simple vocabulary used primarily to convey personal information.\n• Vocabulary inadequate for unfamiliar topics.",
                comment:
                  "Học viên chỉ sử dụng được những từ vựng đơn giản để truyền đạt thông tin cá nhân<br/>" +
                  "Học viên thiếu vốn từ để diễn đạt những chủ đề ít quen thuộc hơn",
                score: 3,
              },
              {
                eComment: "• Resource sufficient for familiar topics but only basic meaning can be conveyed on unfamiliar topics.\n• Frequent inappropriacies and errors in word choice.\n• Rarely attempts paraphrase.",
                comment:
                  "Học viên có vốn từ vựng đủ rộng về các chủ đề quen thuộc. Tuy nhiên, học viên chỉ có thể truyền đạt ý nghĩa cơ bản về các chủ đề không quen thuộc và thường xuyên mắc lỗi trong việc lựa chọn từ ngữ<br/>" +
                  "Hiếm khi cố gắng thay đổi cách diễn đạt (paraphrase)",
                score: 4,
              },
              {
                eComment: "• Resource sufficient to discuss familiar and unfamiliar topics but there is limited flexibility.\n• Attempts paraphrase but not always with success.",
                comment:
                  "Học viên có thể nói được về cả các chủ đề quen thuộc và không quen thuộc nhưng sử dụng từ vựng còn ít linh hoạt<br/>" +
                  "Học viên có cố gắng sử dụng nhiều cách để diễn đạt nhưng thường không thành công",
                score: 5,
              },
              {
                eComment: "• Resource sufficient to discuss topics at length.\n• Vocabulary use may be inappropriate but meaning is clear.\n• Generally able to paraphrase successfully.",
                comment:
                  "Học viên có vốn từ vựng đủ rộng để có những cuộc thảo luận dài về nhiều chủ đề<br/>" +
                  "Học viên sử dụng từ vựng có thể không phù hợp nhưng vẫn thể hiện ý nghĩa rõ ràng<br/>" +
                  "Nhìn chung, học viên diễn đạt ý bằng nhiều cách chính xác",
                score: 6,
              },
              {
                eComment: "• Resource flexibly used to discuss a variety of topics.\n• Some ability to use less common and idiomatic items and an awareness of style and collocation is evident though inappropriacies occur.\n• Effective use of paraphrase as required.",
                comment:
                  "Học viên sử dụng nguồn từ vựng một cách linh hoạt để thảo luận về nhiều chủ đề khác nhau<br/>" +
                  "Học viên sử dụng được một số thành ngữ và các từ vựng ít phổ biến hơn, đồng thời cho thấy một số kiến thức về văn phong và cụm từ, tuy nhiên các sự lựa chọn chưa được phù hợp<br/>" +
                  "Học viên sử dụng hiệu quả nhiều cách diễn đạt (paraphrase) khác nhau",
                score: 7,
              },
              {
                eComment: "• Wide resource, readily and flexibly used to discuss all topics and convey precise meaning.\n• Skilful use of less common and idiomatic items despite occasional inaccuracies in word choice and collocation.\n• Effective use of paraphrase as required.",
                comment:
                  "Học viên sử dụng nguồn từ vựng phong phú và linh hoạt để truyền đạt ý nghĩa một cách chính xác đối với mọi chủ đề<br/>" +
                  "Học viên sử dụng các từ vựng ít phổ biến và thành ngữ một cách khéo léo, chỉ đôi khi không chính xác trong cách dùng từ và collocation<br/>" +
                  "Học viên sử dụng nhiều cách diễn đạt hiệu quả như được yêu cầu",
                score: 8,
              },
              {
                eComment: "• Total flexibility and precise use in all contexts.\n• Sustained use of accurate and idiomatic language.",
                comment:
                  "Học viên sử dụng từ vựng một cách linh hoạt và chính xác trong tất cả các chủ đề<br/>" +
                  "Học viên sử dụng các thành ngữ một cách tự nhiên và chính xác",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "grammaticalRangeAccuracy",
        label: "Grammatical Range & Accuracy",
        items: [
          {
            key: "grammarAccuracy",
            label: "Độ chính xác ngữ pháp",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                eComment: "• No rateable language unless memorised.",
                comment: "Bài nói không đánh giá được ngoại trừ các câu thuộc lòng",
                score: 1,
              },
              {
                eComment: "• No evidence of basic sentence forms.",
                comment: "Học viên không thể hình thành các dạng câu cơ bản",
                score: 2,
              },
              {
                eComment: "• Basic sentence forms are attempted but grammatical errors are numerous except in apparently memorised utterances.",
                comment:
                  "Học viên cố gắng sử dụng các dạng câu cơ bản nhưng có rất nhiều lỗi ngữ pháp ngoại trừ các câu nói có vẻ đã thuộc lòng",
                score: 3,
              },
              {
                eComment: "• Can produce basic sentence forms and some short utterances are error-free.\n• Subordinate clauses are rare and, overall, turns are short, structures are repetitive and errors are frequent.",
                comment:
                  "Học viên hình thành được các dạng câu cơ bản và một số câu đơn giản đúng<br/>" +
                  "Học viên hiếm khi sử dụng các mệnh đề phụ thuộc, nhìn chung, độ dài của các lượt nói ngắn, các cấu trúc lặp lại nhiều lần và thường mắc lỗi",
                score: 4,
              },
              {
                eComment: "• Basic sentence forms are fairly well controlled for accuracy.\n• Complex structures are attempted but these are limited in range, nearly always contain errors and may lead to the need for reformulation.",
                comment:
                  "Học viên sử dụng các dạng câu cơ bản một cách hợp lý và chính xác<br/>" +
                  "Học viên có sử dụng một số ít các cấu trúc phức tạp hơn, nhưng những cấu trúc này thường có lỗi và có thể gây ra một số vấn đề về việc hiểu",
                score: 5,
              },
              {
                eComment: "• Produces a mix of short and complex sentence forms and a variety of structures with limited flexibility.\n• Though errors frequently occur in complex structures, these rarely impede communication.",
                comment:
                  "Học viên sử dụng kết hợp các câu ngắn và phức tạp và đa dạng các cấu trúc nhưng ít linh hoạt<br/>" +
                  "Học viên có thể vẫn mắc lỗi thường xuyên với các cấu trúc phức tạp nhưng những lỗi này hiếm khi cản trở quá trình giao tiếp",
                score: 6,
              },
              {
                eComment: "• A range of structures flexibly used. Error-free sentences are frequent.\n• Both simple and complex sentences are used effectively despite some errors. A few basic errors persist.",
                comment:
                  "Học viên sử dụng nhiều cấu trúc phức tạp một cách khá linh hoạt<br/>" +
                  "Các câu thường không có lỗi, chỉ đôi khi còn một số lỗi ngữ pháp và sử dụng hiệu quả cả câu đơn và câu phức",
                score: 7,
              },
              {
                eComment: "• Wide range of structures, flexibly used.\n• The majority of sentences are error free.\n• Occasional inappropriacies and non-systematic errors occur. A few basic errors may persist.",
                comment:
                  "Học viên sử dụng nhiều và đa dạng các loại cấu trúc một cách linh hoạt<br/>" +
                  "Phần lớn các câu không có lỗi, chỉ thỉnh thoảng không phù hợp hoặc mắc các lỗi cơ bản/ lỗi không hệ thống",
                score: 8,
              },
              {
                eComment: "• Structures are precise and accurate at all times, apart from ‘mistakes’ characteristic of native speaker speech.",
                comment:
                  "Cấu trúc các câu chính xác và nhất quán, loại trừ các “lỗi nhỏ” trong đặc điểm cách nói của người bản ngữ",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "pronunciation",
        label: "Pronunciation",
        items: [
          {
            key: "pronunciationAbility",
            label: "Khả năng phát âm",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                eComment: "• Can produce occasional individual words and phonemes that are recognisable, but no overall meaning is conveyed.\n• Unintelligible.",
                comment:
                  "Đôi khi học viên có thể nói một số từ đơn và âm nhưng nhìn chung không có ý nghĩa<br/>" +
                  "Bài nói hoàn toàn không thể hiểu được",
                score: 1,
              },
              {
                eComment: "• Uses few acceptable phonological features (possibly because sample is insufficient).\n• Overall problems with delivery impair attempts at connected speech.\n• Individual words and phonemes are mainly mispronounced and little meaning is conveyed.\n• Often unintelligible.",
                comment:
                  "Vận dụng được rất ít các thành tố phát âm<br/>" +
                  "Những vấn đề chung về cách truyền đạt ý tưởng ảnh hưởng đến sự cố gắng để nói liền mạch<br/>" +
                  "Học viên phát âm sai hầu hết các từ đơn và âm, chỉ truyền đạt được một ít ý nghĩa của câu nói<br/>" +
                  "Lời nói thường không thể hiểu được",
                score: 2,
              },
              {
                eComment: "• Displays some features of band 2, and some, but not all, of the positive features of band 4.",
                comment:
                  "Thể hiện một số đặc điểm của Band 2 và một số, nhưng không phải tất cả các đặc điểm tích cực của Band 4",
                score: 3,
              },
              {
                eComment: "• Uses some acceptable phonological features, but the range is limited.\n• Produces some acceptable chunking, but there are frequent lapses in overall rhythm.\n• Attempts to use intonation and stress, but control is limited.\n• Individual words or phonemes are frequently mispronounced, causing lack of clarity.\n• Understanding requires some effort and there may be patches of speech that cannot be understood.",
                comment:
                  "Học viên sử dụng được một số ngữ điệu và trọng âm nhưng khả năng kiểm soát còn hạn chế<br/>" +
                  "Học viên liên kết được một số cụm từ nhưng nhịp điệu chung của bài nói có nhiều lỗi<br/>" +
                  "Học viên phát âm sai các từ đơn và âm thường xuyên, khiến bài nói thiếu tính rõ ràng<br/>" +
                  "Gây ra một số khó khăn cho người nghe, một số đoạn có thể không hiểu được",
                score: 4,
              },
              {
                eComment: "• Displays all the positive features of band 4, and some, but not all, of the positive features of band 6.",
                comment:
                  "Thể hiện được tất cả các tính năng tích cực của Band 4 và một số, nhưng không phải tất cả các tính năng tích cực của Band 6",
                score: 5,
              },
              {
                eComment: "• Uses a range of phonological features, but control is variable.\n• Chunking is generally appropriate, but rhythm may be affected by a lack of stress-timing and/or a rapid speech rate.\n• Some effective use of intonation and stress, but this is not sustained.\n• Individual words or phonemes may be mispronounced but this causes only occasional lack of clarity.\n• Can generally be understood throughout without much effort.",
                comment:
                  "Học viên sử dụng được một số các thành tố phát âm nhưng chưa kiểm soát tốt<br/>" +
                  "Học viên liên kết các cụm từ một cách phù hợp, nhưng nhịp điệu nói có thể bị ảnh hưởng bởi cách đặt trọng âm và/hoặc tốc độ nói nhanh<br/>" +
                  "Học viên sử dụng hiệu quả một số ngữ điệu và trọng âm nhưng điều này không được duy trì xuyên suốt bài nói<br/>" +
                  "Nhìn chung, bài nói có thể được hiểu xuyên suốt, mặc dù, việc phát âm sai các từ đơn hoặc âm đôi khi làm giảm độ rõ ràng",
                score: 6,
              },
              {
                eComment: "• Displays all the positive features of band 6, and some, but not all, of the positive features of band 8.",
                comment:
                  "Thể hiện tất cả các tính năng tích cực của Band 6 và một số, nhưng không phải tất cả các tính năng tích cực của Band 8",
                score: 7,
              },
              {
                eComment: "• Uses a wide range of phonological features to convey precise and/or subtle meaning.\n• Can sustain appropriate rhythm. Flexible use of stress and intonation across long utterances, despite occasional lapses.\n• Can be easily understood throughout.\n• Accent has minimal effect on intelligibility.",
                comment:
                  "Học viên sử dụng nhiều và đa dạng các thành tố phát âm với độ chính xác và sự tinh tế<br/>" +
                  "Duy trì nhịp điệu phù hợp, sử dụng linh hoạt trọng âm và ngữ điệu trong các câu nói dài, chỉ thỉnh thoảng mắc lỗi<br/>" +
                  "Xuyên suốt bài nói của học viên dễ hiểu<br/>" +
                  "Ngữ điệu ảnh hưởng rất ít đến độ dễ hiểu của bài nói",
                score: 8,
              },
              {
                eComment: "• Uses a full range of phonological features to convey precise and/or subtle meaning.\n• Flexible use of features of connected speech is sustained throughout.\n• Can be effortlessly understood throughout.\n• Accent has no effect on intelligibility.",
                comment:
                  "Học viên sử dụng đầy đủ các thành tố phát âm với độ chính xác và sự tinh tế<br/>" +
                  "Học viên duy trì việc sử dụng linh hoạt các thành tố này xuyên suốt bài nói<br/>" +
                  "Học viên có thể dễ dàng hiểu mà không cần nỗ lực<br/>" +
                  "Ngữ điệu không ảnh hưởng đến độ dễ hiểu của bài nói",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
    ],
  },
  IEHighWriting: {
    label: "IE High Writing",
    items: [
      {
        key: "taskAchievement",
        label: "Task Achievement",
        items: [
          {
            key: "followRequirementsOfProblem",
            label: "",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "- Bài trả lời có 20 từ trở xuống được chấm Band 1. \n- Nội dung hoàn toàn không liên quan đến yêu cầu đề bài. Mọi phần sao chép từ đề bài không được tính.",
                eComment: "• Responses of 20 words or fewer are rated at Band 1.\n• The content is wholly unrelated to the task.\n• Any copied rubric must be discounted.",
                score: 1,
              },
              {
                comment:
                  "- Nội dung hầu như không liên quan đến yêu cầu đề bài.",
                eComment: "• The content barely relates to the task.",
                score: 2,
              },
              {
                comment:
                  "- Bài làm không đáp ứng yêu cầu đề bài (có thể do hiểu sai dữ liệu/sơ đồ/tình huống). \n- Các đặc điểm chính/ý chính được nêu ra phần lớn không liên quan. \n- Thông tin đưa ra rất hạn chế và có thể bị lặp lại.",
                eComment: "• The response does not address the requirements of the task (possibly because of misunderstanding of the data/diagram/situation).\n• Key features/bullet points which are presented may be largely irrelevant.\n• Limited information is presented, and this may be used repetitively.",
                score: 3,
              },
              {
                comment:
                  "- Bài làm có cố gắng trả lời đề bài. \n- Chỉ chọn được rất ít đặc điểm chính.\n- Hình thức trình bày có thể chưa phù hợp.\n- Các ý chính có thể không liên quan, lặp lại, không chính xác hoặc không phù hợp.",
                eComment: "• The response is an attempt to address the task.\n• Few key features have been selected.\n• The format may be inappropriate.\n• Key features/bullet points which are presented may be irrelevant, repetitive, inaccurate or inappropriate.",
                score: 4,
              },
              {
                comment:
                  "- Bài làm nhìn chung đáp ứng yêu cầu đề bài, nhưng một số chỗ trình bày chưa phù hợp. \n- Các đặc điểm chính được chọn chưa được phát triển đầy đủ. Việc mô tả số liệu còn mang tính máy móc.\n- Có thể thiếu dữ liệu hỗ trợ. Có xu hướng tập trung vào chi tiết mà thiếu cái nhìn tổng thể. \n- Việc đưa vào thông tin không liên quan/không phù hợp/không chính xác làm giảm chất lượng bài. \n- Phần mở rộng và minh họa ý còn hạn chế.",
                eComment: "• The response generally addresses the requirements of the task. The format may be inappropriate in places.\n• Key features which are selected are not adequately covered. The recounting of detail is mainly mechanical. There may be no data to support the description.\n• There may be a tendency to focus on details (without referring to the bigger picture).\n• The inclusion of irrelevant, inappropriate or inaccurate material in key areas detracts from the task achievement.\n• There is limited detail when extending and illustrating the main points.",
                score: 5,
              },
              {
                comment:
                  "- Bài làm tập trung vào yêu cầu đề bài và sử dụng định dạng phù hợp. \n- Các đặc điểm chính được lựa chọn và làm nổi bật tương đối đầy đủ. \n- Có phần tổng quan phù hợp. \n- Thông tin được chọn hợp lý và có số liệu hỗ trợ. \n- Tuy nhiên, vẫn có thể xuất hiện một số chi tiết không liên quan/không chính xác khi minh họa hoặc mở rộng ý. \n- Một số chi tiết có thể thiếu (hoặc thừa) và cần phát triển thêm.",
                eComment: "• The response focuses on the requirements of the task and an appropriate format is used.\n• Key features which are selected are covered and adequately highlighted. A relevant overview is attempted. Information is appropriately selected and supported using figures/data.\n• Some irrelevant, inappropriate or inaccurate information may occur in areas of detail or when illustrating or extending the main points.\n• Some details may be missing (or excessive) and further extension or illustration may be needed.",
                score: 6,
              },
              {
                comment:
                  "- Bài làm đáp ứng đầy đủ yêu cầu đề bài. \n- Nội dung phù hợp và chính xác, dù có thể còn một vài thiếu sót nhỏ.\n- Hình thức trình bày phù hợp. \n- Các đặc điểm chính được nêu và làm rõ, nhưng vẫn có thể phát triển hoặc minh họa đầy đủ hơn.",
                eComment: "• The response covers the requirements of the task.\n• The content is relevant and accurate – there may be a few omissions or lapses. The format is appropriate.\n• Key features which are selected are covered and clearly highlighted but could be more fully or more appropriately illustrated or extended.\n• It presents a clear overview, the data are appropriately categorised, and main trends or differences are identified.",
                score: 7,
              },
              {
                comment:
                  "- Bài làm có phần tổng quan rõ ràng, dữ liệu được phân loại hợp lý, và các xu hướng/khác biệt chính được xác định. \n- Đáp ứng đầy đủ yêu cầu đề bài một cách phù hợp và đầy đủ. \n- Các đặc điểm chính được lựa chọn khéo léo, trình bày rõ ràng và được minh họa tốt. \n- Có thể có lỗi nhỏ không đáng kể.",
                eComment: "• The response covers all the requirements of the task appropriately, relevantly and sufficiently.\n• Key features are skilfully selected, and clearly presented, highlighted and illustrated.\n• There may be occasional omissions or lapses in content.",
                score: 8,
              },
              {
                comment:
                  "- Bài làm đáp ứng hoàn toàn và phù hợp mọi yêu cầu của đề bài. \n- Hầu như không có lỗi về nội dung.",
                eComment: "• All the requirements of the task are fully and appropriately satisfied.\n• There may be extremely rare lapses in content.",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "contentCoherence",
        label: "Coherence & Cohesion",
        items: [
          {
            key: "contentCoherence",
            label: "",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "- Bài viết có 20 từ trở xuống được chấm Band 1. \n- Không truyền tải được bất kỳ thông điệp nào và thể hiện như người gần như không biết viết.",
                eComment: "• Responses of 20 words or fewer are rated at Band 1.\n• The writing fails to communicate any message and appears to be by a virtual non-writer.",
                score: 1,
              },
              {
                comment:
                  "- Nội dung rất ít liên quan, hoặc toàn bộ bài có thể lạc đề. \n- Hầu như không thể hiện khả năng kiểm soát cấu trúc tổ chức bài viết.",
                eComment: "• There is little relevant message, or the entire response may be off-topic.\n• There is little evidence of control of organisational features.",
                score: 2,
              },
              {
                comment:
                  "- Không có tổ chức logic rõ ràng. \n- Các ý có thể nhận ra nhưng khó liên kết với nhau. Sử dụng rất ít từ nối hoặc phương tiện liên kết; những gì được dùng chưa thể hiện rõ quan hệ logic. \n- Khó xác định tham chiếu (reference).",
                eComment: "• There is no apparent logical organisation. Ideas are discernible but difficult to relate to each other.\n• Minimal use of sequencers or cohesive devices. Those used do not necessarily indicate a logical relationship between ideas.\n• There is difficulty in identifying referencing.",
                score: 3,
              },
              {
                comment:
                  "- Có thông tin và ý tưởng nhưng chưa được sắp xếp mạch lạc, không có tiến triển rõ ràng. \n- Mối liên hệ giữa các ý chưa rõ hoặc chưa được thể hiện đầy đủ. \n- Có sử dụng một số phương tiện liên kết cơ bản nhưng có thể sai hoặc lặp lại. \n- Việc dùng tham chiếu/thay thế chưa chính xác hoặc còn thiếu.",
                eComment: "• Information and ideas are evident but not arranged coherently, and there is no clear progression within the response.\n• Relationships between ideas can be unclear and/or inadequately marked. There is some use of basic cohesive devices, which may be inaccurate or repetitive.\n• There is inaccurate use or a lack of substitution or referencing.",
                score: 4,
              },
              {
                comment:
                  "- Có tổ chức bài viết nhưng chưa hoàn toàn logic, có thể thiếu tiến triển tổng thể. \n- Tuy vậy, vẫn có cảm giác mạch lạc chung. Người đọc có thể theo dõi các ý, nhưng các câu chưa liên kết trôi chảy. \n- Có thể dùng hạn chế hoặc lạm dụng từ nối, đôi khi không chính xác. \n- Bài viết có thể bị lặp do dùng tham chiếu/thay thế chưa tốt.",
                eComment: "• Organisation is evident but is not wholly logical and there may be a lack of overall progression. Nevertheless, there is a sense of underlying coherence to the response.\n• The relationship of ideas can be followed but the sentences are not fluently linked to each other.\n• There may be limited/overuse of cohesive devices with some inaccuracy.\n• The writing may be repetitive due to inadequate and/or inaccurate use of reference and substitution.",
                score: 5,
              },
              {
                comment:
                  "- Thông tin và ý tưởng nhìn chung được sắp xếp mạch lạc, có tiến triển rõ ràng.\n- Các phương tiện liên kết được sử dụng tương đối hiệu quả, nhưng liên kết trong/giữa các câu đôi khi còn máy móc hoặc sai do dùng thiếu/thừa/sai. \n- Việc sử dụng tham chiếu và thay thế chưa linh hoạt hoặc rõ ràng, dẫn đến lặp hoặc lỗi.",
                eComment: "• Information and ideas are generally arranged coherently and there is a clear overall progression.\n• Cohesive devices are used to some good effect but cohesion within and/or between sentences may be faulty or mechanical due to misuse, overuse or omission.\n• The use of reference and substitution may lack flexibility or clarity and result in some repetition or error.",
                score: 6,
              },
              {
                comment:
                  "- Thông tin và ý tưởng được tổ chức logic, có tiến triển rõ ràng xuyên suốt bài. \n- Có thể có một vài lỗi nhỏ. Sử dụng đa dạng phương tiện liên kết (bao gồm tham chiếu và thay thế) khá linh hoạt, nhưng vẫn còn một số lỗi hoặc dùng chưa hợp lý.",
                eComment: "• Information and ideas are logically organised and there is a clear progression throughout the response. A few lapses may occur.\n• A range of cohesive devices including reference and substitution is used flexibly but with some inaccuracies or some over/under use.",
                score: 7,
              },
              {
                comment:
                  "- Bài viết dễ theo dõi. \n- Thông tin và ý tưởng được sắp xếp logic, liên kết được kiểm soát tốt.\n- Có thể có lỗi nhỏ không đáng kể. Việc chia đoạn được sử dụng đầy đủ và hợp lý.",
                eComment: "• The message can be followed with ease.\n• Information and ideas are logically sequenced, and cohesion is well managed.\n• Occasional lapses in coherence or cohesion may occur.\n• Paragraphing is used sufficiently and appropriately.",
                score: 8,
              },
              {
                comment:
                  "- Bài viết rất dễ hiểu một cách tự nhiên. \n- Các phương tiện liên kết được sử dụng mượt mà đến mức hầu như không gây chú ý. \n- Lỗi mạch lạc/liên kết là rất hiếm. \n- Kỹ năng chia đoạn được vận dụng thành thạo.",
                eComment: "• The message can be followed effortlessly.\n• Cohesion is used in such a way that it very rarely attracts attention.\n• Any lapses in coherence or cohesion are minimal.\n• Paragraphing is skilfully managed.",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "lexicalResource",
        label: "Lexical Resource",
        items: [
          {
            key: "varietyOfVocabulary",
            label: "",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "- Bài viết có 20 từ trở xuống được chấm Band 1. \n- Hầu như không có vốn từ vựng, ngoài một vài từ rời rạc.",
                eComment: "• Responses of 20 words or fewer are rated at Band 1.\n• No resource is apparent, except for a few isolated words.",
                score: 1,
              },
              {
                comment:
                  "- Vốn từ cực kỳ hạn chế, chỉ có một vài cụm từ nhận diện được (chủ yếu là học thuộc). \n- Không kiểm soát được cấu tạo từ và/hoặc chính tả.",
                eComment: "• The resource is extremely limited with few recognisable strings, apart from memorised phrases.\n• There is no apparent control of word formation and/or spelling.",
                score: 2,
              },
              {
                comment:
                  "- Vốn từ không đủ (có thể do bài quá ngắn). \n- Có thể phụ thuộc nhiều vào đề bài hoặc ngôn ngữ học thuộc.\n- Khả năng chọn từ và/hoặc chính tả rất hạn chế, lỗi chiếm đa số và có thể gây cản trở nghiêm trọng đến việc hiểu nghĩa.",
                eComment: "• The resource is inadequate (which may be due to the response being significantly underlength).\n• Possible over-dependence on input material or memorised language.\n• Control of word choice and/or spelling is very limited, and errors predominate. These errors may severely impede meaning.",
                score: 3,
              },
              {
                comment:
                  "- Vốn từ hạn chế, chưa đủ hoặc không phù hợp với yêu cầu đề bài. \n- Từ vựng cơ bản và có xu hướng lặp lại. Có thể dùng cụm từ học thuộc hoặc không phù hợp. \n- Lỗi chọn từ, cấu tạo từ hoặc chính tả có thể gây khó hiểu.",
                eComment: "• The resource is limited and inadequate for or unrelated to the task. Vocabulary is basic and may be used repetitively.\n• There may be inappropriate use of lexical chunks (e.g. memorised phrases, formulaic language and/or language from the input material).\n• Inappropriate word choice and/or errors in word formation and/or in spelling may impede meaning.",
                score: 4,
              },
              {
                comment:
                  "- Vốn từ còn hạn chế nhưng đủ tối thiểu để đáp ứng đề bài. \n- Từ đơn giản có thể dùng đúng, nhưng phạm vi hẹp nên thiếu đa dạng diễn đạt. \n- Thường xuyên chọn từ chưa phù hợp và thiếu linh hoạt, dẫn đến đơn giản hóa hoặc lặp lại. \n- Lỗi chính tả/cấu tạo từ có thể gây khó khăn nhất định cho người đọc.",
                eComment: "• The resource is limited but minimally adequate for the task.\n• Simple vocabulary may be used accurately but the range does not permit much variation in expression.\n•  There may be frequent lapses in the appropriacy of word choice, and a lack of flexibility is apparent in frequent simplifications and/or repetitions.\n•  Errors in spelling and/or word formation may be noticeable and may cause some difficulty for the reader.",
                score: 5,
              },
              {
                comment:
                  "- Vốn từ nhìn chung đủ và phù hợp với yêu cầu đề bài. \n- Ý nghĩa nhìn chung rõ ràng dù phạm vi từ còn hạn chế hoặc chưa chính xác cao. \n- Nếu người viết cố gắng dùng từ đa dạng hơn thì có thể xuất hiện nhiều lỗi hơn. \n- Có một số lỗi chính tả/cấu tạo từ nhưng không ảnh hưởng đến giao tiếp.",
                eComment: "• The resource is generally adequate and appropriate for the task.\n• The meaning is generally clear in spite of a rather restricted range or a lack of precision in word choice.\n• If the writer is a risk-taker, there will be a wider range of vocabulary used but higher degrees of inaccuracy or inappropriacy.\n• There are some errors in spelling and/or word formation, but these do not impede communication.",
                score: 6,
              },
              {
                comment:
                  "- Vốn từ đủ để thể hiện sự linh hoạt và mức độ chính xác nhất định. \n- Có khả năng sử dụng một số từ ít phổ biến hoặc thành ngữ. \n- Có nhận thức về văn phong và kết hợp từ (collocation), dù vẫn còn lỗi. \n- Một vài lỗi chính tả/cấu tạo từ nhưng không ảnh hưởng đến độ rõ ràng chung.",
                eComment: "• The resource is sufficient to allow some flexibility and precision.\n• There is some ability to use less common and/or idiomatic items.\n• An awareness of style and collocation is evident, though inappropriacies occur.\n• There are only a few errors in spelling and/or word formation, and they do not detract from overall clarity.",
                score: 7,
              },
              {
                comment:
                  "- Sử dụng vốn từ phong phú một cách linh hoạt và trôi chảy để truyền tải ý nghĩa chính xác. \n- Biết sử dụng khéo léo từ ít phổ biến hoặc thành ngữ khi phù hợp, dù đôi khi vẫn có lỗi nhỏ về chọn từ hoặc kết hợp từ. \n- Lỗi chính tả/cấu tạo từ rất ít và hầu như không ảnh hưởng đến giao tiếp.",
                eComment: "• A wide resource is fluently and flexibly used to convey precise meanings within the scope of the task.\n• There is skilful use of uncommon and/or idiomatic items when appropriate, despite occasional inaccuracies in word choice and\ncollocation.\n• Occasional errors in spelling and/or word formation may occur, but have minimal impact on communication.",
                score: 8,
              },
              {
                comment:
                  "- Thể hiện sự linh hoạt hoàn toàn và sử dụng từ chính xác trong phạm vi đề bài. \n- Sử dụng vốn từ đa dạng, chính xác và phù hợp với mức độ tự nhiên và tinh tế cao. \n- Lỗi chính tả/cấu tạo từ cực kỳ hiếm và hầu như không ảnh hưởng đến giao tiếp.",
                eComment: "• Full flexibility and precise use are evident within the scope of the task.\n• A wide range of vocabulary is used accurately and appropriately with very natural and sophisticated control of lexical features.\n• Minor errors in spelling and word formation are extremely rare and have minimal impact on communication.",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "grammarAccuracy",
        label: "Grammatical Range & Accuracy",
        items: [
          {
            key: "grammarAccuracy",
            label: "",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "- Câu trả lời từ 20 từ trở xuống được chấm Band 1. \n- Không thể hiện khả năng sử dụng ngôn ngữ.",
                eComment: "• Responses of 20 words or fewer are rated at Band 1.\n• No rateable language is evident.",
                score: 1,
              },
              {
                comment:
                  "- Hầu như không có hoặc không có bằng chứng về việc sử dụng cấu trúc câu (ngoại trừ các cụm học thuộc).",
                eComment: "• There is little or no evidence of sentence forms (except in memorised phrases).",
                score: 2,
              },
              {
                comment:
                  "- Có cố gắng sử dụng cấu trúc câu, nhưng lỗi ngữ pháp và dấu câu chiếm ưu thế (ngoại trừ các cụm học thuộc hoặc sao chép từ đề bài). \n- Điều này khiến phần lớn ý nghĩa không được truyền tải. Khả năng kiểm soát cấu trúc câu rất hạn chế.",
                eComment: "• Sentence forms are attempted, but errors in grammar and punctuation predominate (except in memorised phrases or those taken from the input material). This prevents most meaning from coming through.\n• Length may be insufficient to provide evidence of control of sentence forms.",
                score: 3,
              },
              {
                comment:
                  "- Sử dụng rất ít cấu trúc đa dạng. \n- Câu đơn chiếm ưu thế, mệnh đề phụ hiếm. \n- Một số cấu trúc được tạo ra chính xác nhưng lỗi ngữ pháp xuất hiện thường xuyên và có thể cản trở ý nghĩa. \n- Dấu câu thường sai hoặc chưa đầy đủ.",
                eComment: "• A very limited range of structures is used.\n• Subordinate clauses are rare and simple sentences predominate.\n• Some structures are produced accurately but grammatical errors are frequent and may impede meaning.\n• Punctuation is often faulty or inadequate.",
                score: 4,
              },
              {
                comment:
                  "- Phạm vi cấu trúc hạn chế và lặp lại. \n- Mặc dù có cố gắng sử dụng câu phức, nhưng thường mắc lỗi; độ chính xác cao nhất nằm ở câu đơn.\n- Lỗi ngữ pháp có thể xảy ra thường xuyên và gây khó khăn nhất định cho người đọc. \n- Dấu câu có thể bị lỗi.",
                eComment: "• The range of structures is limited and rather repetitive.\n• Although complex sentences are attempted, they tend to be faulty, and the greatest accuracy is achieved on simple sentences.\n• Grammatical errors may be frequent and cause some difficulty for the reader.\n• Punctuation may be faulty.",
                score: 5,
              },
              {
                comment:
                  "- Sử dụng kết hợp câu đơn và câu phức nhưng độ linh hoạt còn hạn chế. \n- Các cấu trúc phức không đạt độ chính xác như câu đơn.\n- Lỗi ngữ pháp và dấu câu xuất hiện, nhưng hiếm khi làm cản trở giao tiếp.",
                eComment: "• A mix of simple and complex sentence forms is used but flexibility is limited.\n• Examples of more complex structures are not marked by the same level of accuracy as in simple structures.\n• Errors in grammar and punctuation occur, but rarely impede communication",
                score: 6,
              },
              {
                comment:
                  "- Sử dụng đa dạng cấu trúc phức với mức độ linh hoạt và chính xác nhất định.\n- Ngữ pháp và dấu câu nhìn chung được kiểm soát tốt; câu không lỗi xuất hiện thường xuyên.\n- Một số lỗi vẫn tồn tại nhưng không ảnh hưởng đến giao tiếp.",
                eComment: "• A variety of complex structures is used with some flexibility and accuracy.\n• Grammar and punctuation are generally well controlled, and error-free sentences are frequent.\n• A few errors in grammar may persist, but these do not impede communication.",
                score: 7,
              },
              {
                comment:
                  "- Sử dụng phạm vi rộng các cấu trúc phù hợp với yêu cầu bài viết một cách linh hoạt và chính xác. \n- Phần lớn câu không có lỗi và dấu câu được kiểm soát tốt.\n- Thỉnh thoảng có lỗi nhỏ, không hệ thống, nhưng ảnh hưởng rất ít đến giao tiếp.",
                eComment: "• A wide range of structures within the scope of the task is flexibly and accurately used.\n• The majority of sentences are error-free, and punctuation is well managed.\n• Occasional, non-systematic errors and inappropriacies occur, but have minimal impact on communication.",
                score: 8,
              },
              {
                comment:
                  "- Sử dụng rất đa dạng cấu trúc một cách linh hoạt và kiểm soát tốt. \n- Ngữ pháp và dấu câu chính xác và phù hợp xuyên suốt. \n- Lỗi nhỏ rất hiếm và hầu như không ảnh hưởng đến giao tiếp.",
                eComment: "• A wide range of structures within the scope of the task is used with full flexibility and control.\n• Punctuation and grammar are used appropriately throughout.\n• Minor errors are extremely rare and have minimal impact on communication",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
    ],
  },
  IEHighWriting2: {
    label: "IE High Writing",
    items: [
      {
        key: "taskResponse",
        label: "Task Response",
        items: [
          {
            key: "followRequirementsOfProblem",
            label: "",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "- Câu trả lời từ 20 từ trở xuống được chấm Band 1. \n- Nội dung hoàn toàn không liên quan đến đề bài. \n- Mọi nội dung sao chép từ rubric phải bị loại trừ.",
                eComment: "• Responses of 20 words or fewer are rated at Band 1.\n• The content is wholly unrelated to the prompt.\n• Any copied rubric must be discounted.",
                score: 1,
              },
              {
                comment:
                  "- Nội dung hầu như không liên quan đến đề bài. \n- Không xác định được quan điểm. \n- Có thể xuất hiện một hoặc hai ý nhưng không được phát triển.",
                eComment: "• The content is barely related to the prompt.\n• No position can be identified.\n• There may be glimpses of one or two ideas without development.",
                score: 2,
              },
              {
                comment:
                  "- Không phần nào của đề bài được xử lý đầy đủ hoặc thí sinh hiểu sai đề. \n- Không xác định được quan điểm rõ ràng và/hoặc phản hồi rất hạn chế đối với câu hỏi. \n- Có rất ít ý, thường không liên quan hoặc phát triển chưa đầy đủ.",
                eComment: "• No part of the prompt is adequately addressed, or the prompt has been misunderstood.\n• No relevant position can be identified, and/or there is little direct response to the question/s.\n• There are few ideas, and these may be irrelevant or insufficiently developed.",
                score: 3,
              },
              {
                comment:
                  "- Đề bài chỉ được xử lý ở mức tối thiểu; câu trả lời mang tính lạc đề, có thể do hiểu sai đề. \n- Bố cục có thể không phù hợp. Có thể nhận thấy quan điểm nhưng người đọc phải đọc kỹ mới nhận ra. \n- Các ý chính khó xác định; nếu có thì thiếu liên quan, rõ ràng và/hoặc hỗ trợ. Nhiều phần bị lặp lại.",
                eComment: "• The prompt is tackled in a minimal way, or the answer is tangential, possibly due to some misunderstanding of the prompt. The format may be inappropriate.\n• A position is discernible, but the reader has to read carefully to find it.\n• Main ideas are difficult to identify and such ideas that are identifiable may lack relevance, clarity and/or support.\n• Large parts of the response may be repetitive.",
                score: 4,
              },
              {
                comment:
                  "- Các phần chính của đề bài được xử lý nhưng chưa đầy đủ. Bố cục đôi chỗ chưa phù hợp. \n- Có quan điểm nhưng phát triển chưa rõ ràng. Một số ý chính được nêu nhưng còn hạn chế, chưa phát triển đầy đủ và/hoặc chưa liên quan. \n- Có thể có sự lặp lại.",
                eComment: "• The main parts of the prompt are incompletely addressed. The format may be inappropriate in places.\n• The writer expresses a position, but the development is not always clear.\n• Some main ideas are put forward, but they are limited and are not sufficiently developed and/or there may be irrelevant detail.\n• There may be some repetition.",
                score: 5,
              },
              {
                comment:
                  "- Các phần chính của đề bài được xử lý (một số phần có thể được phát triển tốt hơn các phần khác). \n- Sử dụng bố cục phù hợp.  Có quan điểm rõ ràng liên quan trực tiếp đến đề bài, nhưng kết luận có thể chưa rõ, thiếu thuyết phục hoặc còn lặp lại. \n- Các ý chính có liên quan nhưng có thể chưa được phát triển đầy đủ hoặc thiếu rõ ràng; một số luận điểm và dẫn chứng hỗ trợ có thể chưa phù hợp hoặc chưa đủ.",
                eComment: "• The main parts of the prompt are addressed (though some may be more fully covered than others). An appropriate format is used.\n• A position is presented that is directly relevant to the prompt, although the conclusions drawn may be unclear, unjustified or repetitive.\n• Main ideas are relevant, but some may be insufficiently developed or may lack clarity, while some supporting arguments and evidence may be less relevant or inadequate.",
                score: 6,
              },
              {
                comment:
                  "- Các phần chính của đề bài được xử lý phù hợp. \n- Quan điểm rõ ràng và được phát triển. \n- Các ý chính được mở rộng và hỗ trợ, nhưng có xu hướng khái quát hóa quá mức hoặc thiếu trọng tâm và độ chính xác trong việc hỗ trợ ý tưởng/dẫn chứng.",
                eComment: "• The main parts of the prompt are appropriately addressed.\n• A clear and developed position is presented.\n• Main ideas are extended and supported but there may be a tendency to over-generalise or there may be a lack of focus and precision in supporting ideas/material.",
                score: 7,
              },
              {
                comment:
                  "- Đề bài được xử lý đầy đủ và phù hợp. \n- Có quan điểm rõ ràng, được phát triển tốt để trả lời câu hỏi. \n- Các ý có liên quan, được mở rộng và hỗ trợ. \n- Chỉ có một vài thiếu sót nhỏ hoặc gián đoạn về nội dung.",
                eComment: "• The prompt is appropriately and sufficiently addressed.\n• A clear and well-developed position is presented in response to the question/s.\n• Ideas are relevant, well extended and supported.\n• There may be occasional omissions or lapses in content.",
                score: 8,
              },
              {
                comment:
                  "- Đề bài được xử lý đầy đủ và chuyên sâu. \n- Quan điểm rõ ràng, được phát triển toàn diện và trả lời trực tiếp câu hỏi. \n- Các ý liên quan, được phát triển đầy đủ và có hỗ trợ. \n- Sai sót về nội dung hoặc lập luận là cực kỳ hiếm.",
                eComment: "• The prompt is appropriately addressed and explored in depth.\n• A clear and fully developed position is presented which directly answers the question/s.\n• Ideas are relevant, fully extended and well supported.\n• Any lapses in content or support are extremely rare.",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "contentCoherence",
        label: "Coherence & Cohesion",
        items: [
          {
            key: "contentCoherence",
            label: "",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "- Câu trả lời từ 20 từ trở xuống được chấm Band 1. \n- Bài viết không truyền tải được thông điệp nào và có vẻ như không phải do người viết thực hiện.",
                eComment: "• Responses of 20 words or fewer are rated at Band 1.\n• The writing fails to communicate any message and appears to be by a virtual non-writer.",
                score: 1,
              },
              {
                comment:
                  "- Có rất ít thông điệp liên quan hoặc toàn bộ câu trả lời có thể bị lạc đề. \n- Hầu như không có bằng chứng về các yếu tố tổ chức bài viết.",
                eComment: "• There is little relevant message, or the entire response may\nbe off-topic.\n• There is little evidence of control of organisational features.",
                score: 2,
              },
              {
                comment:
                  "- Không có tổ chức logic rõ ràng. Các ý có thể nhận diện nhưng khó liên kết với nhau. \n- Việc sử dụng các công cụ liên kết hoặc trình tự sắp xếp là rất hạn chế; những gì được sử dụng không nhất thiết thể hiện mối quan hệ logic giữa các ý. \n- Gặp khó khăn trong việc xác định tham chiếu. \n- Mọi nỗ lực chia đoạn đều không hiệu quả.",
                eComment: "• There is no apparent logical organisation. Ideas are discernible but difficult to relate to each other.\n• There is minimal use of sequencers or cohesive devices. Those used do not necessarily indicate a logical relationship between ideas.\n• There is difficulty in identifying referencing.\n• Any attempts at paragraphing are unhelpful.",
                score: 3,
              },
              {
                comment:
                  "- Thông tin và ý tưởng có xuất hiện nhưng chưa được sắp xếp mạch lạc, không có tiến trình rõ ràng trong bài. \n- Mối quan hệ giữa các ý chưa rõ ràng hoặc được thể hiện chưa đầy đủ. \n- Có sử dụng một số công cụ liên kết cơ bản nhưng có thể không chính xác hoặc lặp lại.\n- Việc thay thế và tham chiếu chưa chính xác hoặc còn thiếu. \n- Có thể không chia đoạn hoặc thiếu câu chủ đề rõ ràng trong từng đoạn.",
                eComment: "• Information and ideas are evident but not arranged coherently and there is no clear progression within the response.\n• Relationships between ideas can be unclear and/or inadequately marked. There is some use of basic cohesive devices, which may be inaccurate or repetitive.\n• There is inaccurate use or a lack of substitution or referencing.\n• There may be no paragraphing and/or no clear main topic within paragraphs.",
                score: 4,
              },
              {
                comment:
                  "- Có tổ chức nhưng chưa hoàn toàn logic và có thể thiếu tiến trình tổng thể. \n- Tuy vậy, vẫn có cảm nhận về sự mạch lạc chung. \n- Mối liên hệ giữa các ý có thể theo dõi được nhưng các câu chưa được liên kết trôi chảy. \n- Việc sử dụng công cụ liên kết còn hạn chế và có thể chưa chính xác. \n- Bài viết có thể bị lặp do sử dụng tham chiếu và thay thế chưa hiệu quả. \n- Chia đoạn có thể chưa hợp lý hoặc còn thiếu.",
                eComment: "• Organisation is evident but is not wholly logical and there may be a lack of overall progression. Nevertheless, there is a sense of underlying coherence to the response.\n• The relationship of ideas can be followed but the sentences are not fluently linked to each other.\n• There may be limited/overuse of cohesive devices with some inaccuracy.\n• The writing may be repetitive due to inadequate and/or inaccurate use of reference and substitution.\n• Paragraphing may be inadequate or missing.",
                score: 5,
              },
              {
                comment:
                  "- Thông tin và ý tưởng nhìn chung được sắp xếp mạch lạc và có tiến trình tổng thể rõ ràng. \n- Công cụ liên kết được sử dụng hiệu quả ở một mức độ nhất định, nhưng có thể còn lỗi hoặc mang tính máy móc do dùng sai, lạm dụng hoặc thiếu. \n- Việc sử dụng tham chiếu và thay thế có thể thiếu linh hoạt hoặc rõ ràng, dẫn đến lặp lại hoặc lỗi. \n- Chia đoạn có thể chưa hoàn toàn logic và/hoặc câu chủ đề chưa rõ.",
                eComment: "• Information and ideas are generally arranged coherently and there is a clear overall progression.\n• Cohesive devices are used to some good effect but cohesion within and/or between sentences may be faulty or mechanical due to misuse, overuse or omission.\n• The use of reference and substitution may lack flexibility or clarity and result in some repetition or error.\n• Paragraphing may not always be logical and/or the central topic may not always be clear.",
                score: 6,
              },
              {
                comment:
                  "- Thông tin và ý tưởng được tổ chức logic, với tiến trình rõ ràng xuyên suốt bài. (Một số thiếu sót nhỏ về liên kết có thể vẫn xảy ra.) \n- Sử dụng đa dạng công cụ liên kết và tham chiếu một cách linh hoạt, dù vẫn có một số lỗi hoặc lạm dụng/thiếu. \n- Chia đoạn nhìn chung hiệu quả trong việc hỗ trợ tính mạch lạc tổng thể; trình tự sắp xếp ý trong đoạn nhìn chung hợp lý.",
                eComment: "• Information and ideas are logically organised, and there is a clear progression throughout the response. (A few lapses may occur, but these are minor.)\n• A range of cohesive devices including reference and substitution is used flexibly but with some inaccuracies or some over/under use.\n• Paragraphing is generally used effectively to support overall coherence, and the sequencing of ideas within a paragraph is generally logical.",
                score: 7,
              },
              {
                comment:
                  "- Thông điệp dễ dàng được theo dõi. \n- Thông tin và ý tưởng được sắp xếp logic, tính liên kết được kiểm soát tốt. \n- Thỉnh thoảng vẫn có lỗi nhỏ về mạch lạc hoặc liên kết. \n- Chia đoạn được sử dụng đầy đủ và phù hợp.",
                eComment: "• The message can be followed with ease.\n• Information and ideas are logically sequenced, and cohesion is well managed.\n• Occasional lapses in coherence and cohesion may occur.\n• Paragraphing is used sufficiently and appropriately.",
                score: 8,
              },
              {
                comment:
                  "- Thông điệp được theo dõi một cách dễ dàng. \n- Liên kết được sử dụng khéo léo đến mức hầu như không gây chú ý. \n- Các lỗi về mạch lạc hoặc liên kết là tối thiểu. \n- Chia đoạn được xử lý một cách thành thạo.",
                eComment: "• The message can be followed effortlessly.\n• Cohesion is used in such a way that it very rarely attracts attention.\n• Any lapses in coherence or cohesion are minimal.\n• Paragraphing is skilfully managed.",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "lexicalResource",
        label: "Lexical Resource",
        items: [
          {
            key: "varietyOfVocabulary",
            label: "",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                comment:
                  "- Bài viết có 20 từ trở xuống được chấm Band 1. \n- Hầu như không có vốn từ vựng, ngoài một vài từ rời rạc.",
                eComment: "• Responses of 20 words or fewer are rated at Band 1.\n• No resource is apparent, except for a few isolated words.",
                score: 1,
              },
              {
                comment:
                  "- Vốn từ cực kỳ hạn chế, chỉ có một vài cụm từ nhận diện được (chủ yếu là học thuộc). \n- Không kiểm soát được cấu tạo từ và/hoặc chính tả.",
                eComment: "• The resource is extremely limited with few recognisable strings, apart from memorised phrases.\n• There is no apparent control of word formation and/or spelling.",
                score: 2,
              },
              {
                comment:
                  "- Vốn từ không đủ (có thể do bài quá ngắn). \n- Có thể phụ thuộc nhiều vào đề bài hoặc ngôn ngữ học thuộc.\n- Khả năng chọn từ và/hoặc chính tả rất hạn chế, lỗi chiếm đa số và có thể gây cản trở nghiêm trọng đến việc hiểu nghĩa.",
                eComment: "• The resource is inadequate (which may be due to the response being significantly underlength). Possible over-dependence on input material or memorised language.\n• Control of word choice and/or spelling is very limited, and errors predominate. These errors may severely impede meaning.",
                score: 3,
              },
              {
                comment:
                  "- Vốn từ hạn chế, chưa đủ hoặc không phù hợp với yêu cầu đề bài. \n- Từ vựng cơ bản và có xu hướng lặp lại. \n- Có thể dùng cụm từ học thuộc hoặc không phù hợp. \n- Lỗi chọn từ, cấu tạo từ hoặc chính tả có thể gây khó hiểu.",
                eComment: "• The resource is limited and inadequate for or unrelated to the task. Vocabulary is basic and may be used repetitively.\n• There may be inappropriate use of lexical chunks (e.g. memorised phrases, formulaic language and/or language from the input material).\n• Inappropriate word choice and/or errors in word formation and/or in spelling may impede meaning.",
                score: 4,
              },
              {
                comment:
                  "- Vốn từ còn hạn chế nhưng đủ tối thiểu để đáp ứng đề bài. \n- Từ đơn giản có thể dùng đúng, nhưng phạm vi hẹp nên thiếu đa dạng diễn đạt. \n- Thường xuyên chọn từ chưa phù hợp và thiếu linh hoạt, dẫn đến đơn giản hóa hoặc lặp lại.\n- Lỗi chính tả/cấu tạo từ có thể gây khó khăn nhất định cho người đọc.",
                eComment: "• The resource is limited but minimally adequate for the task.\n• Simple vocabulary may be used accurately but the range does not permit much variation in expression.\n• There may be frequent lapses in the appropriacy of word choice and a lack of flexibility is apparent in frequent simplifications and/or repetitions.\n• Errors in spelling and/or word formation may be noticeable and may cause some difficulty for the reader.",
                score: 5,
              },
              {
                comment:
                  "- Vốn từ nhìn chung đủ và phù hợp với yêu cầu đề bài. \n- Ý nghĩa nhìn chung rõ ràng dù phạm vi từ còn hạn chế hoặc chưa chính xác cao. \n- Nếu người viết cố gắng dùng từ đa dạng hơn thì có thể xuất hiện nhiều lỗi hơn. \n- Có một số lỗi chính tả/cấu tạo từ nhưng không ảnh hưởng đến giao tiếp.",
                eComment: "• The resource is generally adequate and appropriate for the task.\n• The meaning is generally clear in spite of a rather restricted range or a lack of precision in word choice.\n• If the writer is a risk-taker, there will be a wider range of vocabulary used but higher degrees of inaccuracy or inappropriacy.\n• There are some errors in spelling and/or word formation, but these do not impede communication.",
                score: 6,
              },
              {
                comment:
                  "- Vốn từ đủ để thể hiện sự linh hoạt và mức độ chính xác nhất định. \n- Có khả năng sử dụng một số từ ít phổ biến hoặc thành ngữ. \n- Có nhận thức về văn phong và kết hợp từ (collocation), dù vẫn còn lỗi.\n- Một vài lỗi chính tả/cấu tạo từ nhưng không ảnh hưởng đến độ rõ ràng chung.",
                eComment: "• The resource is sufficient to allow some flexibility and precision.\n• There is some ability to use less common and/or idiomatic items.\n• An awareness of style and collocation is evident, though inappropriacies occur.\n• There are only a few errors in spelling and/or word formation and they do not detract from overall clarity.",
                score: 7,
              },
              {
                comment:
                  "- Sử dụng vốn từ phong phú một cách linh hoạt và trôi chảy để truyền tải ý nghĩa chính xác. \n- Biết sử dụng khéo léo từ ít phổ biến hoặc thành ngữ khi phù hợp, dù đôi khi vẫn có lỗi nhỏ về chọn từ hoặc kết hợp từ. \n- Lỗi chính tả/cấu tạo từ rất ít và hầu như không ảnh hưởng đến giao tiếp.",
                eComment: "• A wide resource is fluently and flexibly used to convey precise meanings.\n• There is skilful use of uncommon and/or idiomatic items when appropriate, despite occasional inaccuracies in word choice and collocation.\n• Occasional errors in spelling and/or word formation may occur, but have minimal impact on communication.",
                score: 8,
              },
              {
                comment:
                  "- Thể hiện sự linh hoạt hoàn toàn và sử dụng từ chính xác trong phạm vi đề bài. \n- Sử dụng vốn từ đa dạng, chính xác và phù hợp với mức độ tự nhiên và tinh tế cao.\n- Lỗi chính tả/cấu tạo từ cực kỳ hiếm và hầu như không ảnh hưởng đến giao tiếp.",
                eComment: "• Full flexibility and precise use are widely evident.\n• A wide range of vocabulary is used accurately and appropriately with very natural and sophisticated control of lexical features.\n• Minor errors in spelling and word formation are extremely rare and have minimal impact on communication.",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "grammarAccuracy",
        label: "Grammatical Range & Accuracy",
        items:[ {
          key: "grammarAccuracy",
          label: "",
          comment_auto: "",
          criterion_score: "",
          items: [
            {
              comment:
                "- Câu trả lời từ 20 từ trở xuống được chấm Band 1. \n- Không thể hiện khả năng sử dụng ngôn ngữ.",
                            eComment: "• Responses of 20 words or fewer are rated at Band 1.\nNo rateable language is evident.",
                score: 1,
            },
            {
              comment:
                "- Hầu như không có hoặc không có bằng chứng về việc sử dụng cấu trúc câu (ngoại trừ các cụm học thuộc).",
                            eComment: "• There is little or no evidence of sentence forms (except in memorised phrases).",
                score: 2,
            },
            {
              comment:
                "- Có cố gắng sử dụng cấu trúc câu, nhưng lỗi ngữ pháp và dấu câu chiếm ưu thế (ngoại trừ các cụm học thuộc hoặc sao chép từ đề bài). \n- Điều này khiến phần lớn ý nghĩa không được truyền tải. \n- Khả năng kiểm soát cấu trúc câu rất hạn chế.",
                            eComment: "• Sentence forms are attempted, but errors in grammar and punctuation predominate (except in memorised phrases or those taken from the input material). This prevents most meaning from coming through.\n• Length may be insufficient to provide evidence of control of sentence forms.",
                score: 3,
            },
            {
              comment:
                "- Sử dụng rất ít cấu trúc đa dạng. \n- Câu đơn chiếm ưu thế, mệnh đề phụ hiếm. \n- Một số cấu trúc được tạo ra chính xác nhưng lỗi ngữ pháp xuất hiện thường xuyên và có thể cản trở ý nghĩa. \n- Dấu câu thường sai hoặc chưa đầy đủ.",
                            eComment: "• A very limited range of structures is used.\n• Subordinate clauses are rare and simple sentences predominate.\n• Some structures are produced accurately but grammatical errors are frequent and may impede meaning.\n• Punctuation is often faulty or inadequate.",
                score: 4,
            },
            {
              comment:
                "- Phạm vi cấu trúc hạn chế và lặp lại. \n- Mặc dù có cố gắng sử dụng câu phức, nhưng thường mắc lỗi; độ chính xác cao nhất nằm ở câu đơn. \n- Lỗi ngữ pháp có thể xảy ra thường xuyên và gây khó khăn nhất định cho người đọc.\n- Dấu câu có thể bị lỗi.",
                            eComment: "• The range of structures is limited and rather repetitive.\n• Although complex sentences are attempted, they tend to be faulty, and the greatest accuracy is achieved on simple sentences.\n• Grammatical errors may be frequent and cause some difficulty for the reader.\n• Punctuation may be faulty.",
                score: 5,
            },
            {
              comment:
                "- Sử dụng kết hợp câu đơn và câu phức nhưng độ linh hoạt còn hạn chế. \n- Các cấu trúc phức không đạt độ chính xác như câu đơn. \n- Lỗi ngữ pháp và dấu câu xuất hiện, nhưng hiếm khi làm cản trở giao tiếp.",
                            eComment: "• A mix of simple and complex sentence forms is used but flexibility is limited.\n• Examples of more complex structures are not marked by the same level of accuracy as in simple structures.\n• Errors in grammar and punctuation occur, but rarely impede communication.",
                score: 6,
            },
            {
              comment:
                "- Sử dụng đa dạng cấu trúc phức với mức độ linh hoạt và chính xác nhất định.\n- Ngữ pháp và dấu câu nhìn chung được kiểm soát tốt; câu không lỗi xuất hiện thường xuyên. \n- Một số lỗi vẫn tồn tại nhưng không ảnh hưởng đến giao tiếp.",
                            eComment: "• A variety of complex structures is used with some flexibility and accuracy.\n• Grammar and punctuation are generally well controlled, and error-free sentences are frequent.\n• A few errors in grammar may persist, but these do not impede communication.",
                score: 7,
            },
            {
              comment:
                "- Sử dụng phạm vi rộng các cấu trúc phù hợp với yêu cầu bài viết một cách linh hoạt và chính xác. \n- Phần lớn câu không có lỗi và dấu câu được kiểm soát tốt. \n- Thỉnh thoảng có lỗi nhỏ, không hệ thống, nhưng ảnh hưởng rất ít đến giao tiếp.",
                            eComment: "• A wide range of structures is flexibly and accurately used.\n• The majority of sentences are error-free, and punctuation is well managed.\n• Occasional, non-systematic errors and inappropriacies occur, but have minimal impact on communication.",
                score: 8,
            },
            {
              comment:
                "- Sử dụng rất đa dạng cấu trúc một cách linh hoạt và kiểm soát tốt. \n- Ngữ pháp và dấu câu chính xác và phù hợp xuyên suốt. \n- Lỗi nhỏ rất hiếm và hầu như không ảnh hưởng đến giao tiếp.",
                            eComment: "• A wide range of structures is used with full flexibility and control.\n• Punctuation and grammar are used appropriately throughout.\n• Minor errors are extremely rare and have minimal impact on communication.",
                score: 9,
            },
          ],
        }]
       ,
        comment_detail: "",
      },
    ],
  },
  IEWritingEntrance: {
    label: "IE High Writing Entrance",
    items: [
      {
        key: "taskAchievement",
        label: "Task Achievement",
        items: [
          {
            key: "followRequirementsOfProblem",
            label: "",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                eComment: "• Responses of 20 words or fewer are rated at Band 1.\n• The content is wholly unrelated to the task.\n• Any copied rubric must be discounted.",
                comment:
                  "Bài viết của học viên dưới 20 từ được chấm ở Band 1<br />" +
                  "Nội dung bài viết hoàn toàn không liên quan đến đề bài<br />" +
                  "Bất kỳ phần sao chép nào từ đề thì bài viết phải bị loại bỏ",
                score: 1,
              },
              {
                eComment: "• The content barely relates to the task.",
                comment: "Bài viết hầu như không liên quan đến đề bài",
                score: 2,
              },
              {
                eComment: "• The response does not address the requirements of the task (possibly because of misunderstanding of the data/diagram/situation).\n• Key features/bullet points which are presented may be largely irrelevant.\n• Limited information is presented, and this may be used repetitively.",
                comment:
                  "Bài viết không đáp ứng đúng yêu cầu, (có thể do hiểu sai dữ liệu/biểu đồ/tình huống)<br />" +
                  "Ý tưởng của bài viết phần lớn không liên quan<br />" +
                  "Thông tin của bài viết đưa ra còn hạn chế, có thể lặp lại",
                score: 3,
              },
              {
                eComment: "• The response is an attempt to address the task.\n• Few key features have been selected.\n• The format may be inappropriate.\n• Key features/bullet points which are presented may be irrelevant, repetitive, inaccurate or inappropriate.",
                comment:
                  "Học viên có thể hoàn thành bài viết, nhưng các câu trả lời bị lạc đề<br />" +
                  "Các ý chính được trình bày có thể không liên quan, lặp lại, thiếu chính xác hoặc không phù hợp",
                score: 4,
              },
              {
                eComment: "• The response generally addresses the requirements of the task. The format may be inappropriate in places.\n• Key features which are selected are not adequately covered. The recounting of detail is mainly mechanical. There may be no data to support the description.\n• There may be a tendency to focus on details (without referring to the bigger picture).\n• The inclusion of irrelevant, inappropriate or inaccurate material in key areas detracts from the task achievement.\n• There is limited detail when extending and illustrating the main points.",
                comment:
                  "Học viên cố gắng hoàn thành yêu cầu nhưng không bao quát tất cả các ý chính/gạch đầu dòng chính; cấu trúc bài viết có thể không phù hợp<br />" +
                  "Bài viết thường chỉ liệt kê số liệu, thiếu phân tích, có thể không dùng số liệu minh chứng<br />" +
                  "Bài viết có thông tin thừa, sai hoặc không liên quan, các ý chính chưa được mở rộng hay minh họa tốt",
                score: 5,
              },
              {
                eComment: "• The response focuses on the requirements of the task and an appropriate format is used.\n• Key features which are selected are covered and adequately highlighted. A relevant overview is attempted. Information is appropriately selected and supported using figures/data.\n• Some irrelevant, inappropriate or inaccurate information may occur in areas of detail or when illustrating or extending the main points.\n• Some details may be missing (or excessive) and further extension or illustration may be needed.",
                comment:
                  "Nhìn chung, bài viết đã đáp ứng yêu cầu cơ bản của đề bài; cấu trúc có thể không phù hợp ở một số đoạn<br />" +
                  "Bài viết miêu tả lại chi tiết một cách máy móc mà không có cái nhìn tổng quan rõ ràng; có thể không có dữ liệu để hỗ trợ cho phần miêu tả<br />" +
                  "Nội dung thường chỉ tập trung vào các ý chính mà thiếu đi sự chi tiết hoặc minh họa",
                score: 6,
              },
              {
                eComment: "• The response covers the requirements of the task.\n• The content is relevant and accurate – there may be a few omissions or lapses. The format is appropriate.\n• Key features which are selected are covered and clearly highlighted but could be more fully or more appropriately illustrated or extended.\n• It presents a clear overview, the data are appropriately categorised, and main trends or differences are identified.",
                comment:
                  "Bài viết đáp ứng được yêu cầu của đề bài với một số thiếu sót nhỏ<br />" +
                  "Bài viết trình bày tổng quan với thông tin được lựa chọn phù hợp<br />" +
                  "Các đặc điểm chính được chọn và làm nổi bật rõ ràng, mặc dù có thể cần bổ sung hoặc minh họa thêm.",
                score: 7,
              },
              {
                eComment: "• The response covers all the requirements of the task appropriately, relevantly and sufficiently.\n• Key features are skilfully selected, and clearly presented, highlighted and illustrated.\n• There may be occasional omissions or lapses in content.",
                comment:
                  "Bài viết thực hiện đúng yêu cầu của đề bài, có thể có một vài thiếu sót nhỏ<br />" +
                  "Bài viết chọn lọc đặc điểm chính rất tốt, trình bày rõ ràng, minh họa hợp lý<br />" +
                  "Bài viết có thể còn vài thiếu sót nhỏ nhưng không đáng kể",
                score: 8,
              },
              {
                eComment: "• All the requirements of the task are fully and appropriately satisfied.\n• There may be extremely rare lapses in content.",
                comment:
                  "Bài viết đáp ứng đầy đủ và chính xác tất cả yêu cầu đề bài<br />" +
                  "Nội dung hoàn chỉnh, không có bất kỳ thiếu sót nào, và mọi thông tin đều được trình bày chi tiết, phù hợp",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "contentCoherence",
        label: "Coherence & Cohesion",
        items: [
          {
            key: "contentCoherence",
            label: "",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                eComment: "• Responses of 20 words or fewer are rated at Band 1.\n• The writing fails to communicate any message and appears to be by a virtual non-writer.",
                comment:
                  "Bài viết của học viên dưới 20 từ được chấm ở Band 1<br />" +
                  "Không có sự tổ chức nào trong bài viết, không có gắn kết giữa các câu",
                score: 1,
              },
              {
                eComment: "• There is little relevant message, or the entire response may be off-topic.\n• There is little evidence of control of organisational features.",
                comment:
                  "Bài viết hầu như không sắp xếp được ý tưởng cho bài viết hoặc toàn bộ nội dung có thể lạc đề",
                score: 2,
              },
              {
                eComment: "• There is no apparent logical organisation. Ideas are discernible but difficult to relate to each other.\n• Minimal use of sequencers or cohesive devices. Those used do not necessarily indicate a logical relationship between ideas.\n• There is difficulty in identifying referencing.",
                comment:
                  "Bài viết không có tổ chức logic, ý có nhưng khó nối kết với nhau<br />" +
                  "Bài viết sử dụng rất hạn chế các liên kết và các từ nối và những từ được sử dụng có thể chưa chỉ ra được mối quan hệ logic giữa các ý tưởng",
                score: 3,
              },
              {
                eComment: "• Information and ideas are evident but not arranged coherently, and there is no clear progression within the response.\n• Relationships between ideas can be unclear and/or inadequately marked. There is some use of basic cohesive devices, which may be inaccurate or repetitive.\n• There is inaccurate use or a lack of substitution or referencing.",
                comment:
                  "Bài viết đã trình bày được các thông tin và ý tưởng. Tuy nhiên, các ý tưởng được sắp xếp chưa mạch lạc và không có sự phát triển rõ ràng trong câu trả lời<br />" +
                  "Sử dụng một số từ nối cơ bản nhưng những từ này có thể không chính xác hoặc lặp đi lặp lại",
                score: 4,
              },
              {
                eComment: "• Organisation is evident but is not wholly logical and there may be a lack of overall progression. Nevertheless, there is a sense of underlying coherence to the response.\n• The relationship of ideas can be followed but the sentences are not fluently linked to each other.\n• There may be limited/overuse of cohesive devices with some inaccuracy.\n• The writing may be repetitive due to inadequate and/or inaccurate use of reference and substitution.",
                comment:
                  "Bài viết trình bày thông tin với một trật tự nhất định nhưng tổng thể chưa phù hợp<br />" +
                  "Các từ nối sử dụng trong bài chưa đầy đủ, không chính xác hoặc lạm dụng<br />" +
                  "Bài viết có thể lặp đi lặp lại vì thiếu tham chiếu và các từ thay thế",
                score: 5,
              },
              {
                eComment: "• Information and ideas are generally arranged coherently and there is a clear overall progression.\n• Cohesive devices are used to some good effect but cohesion within and/or between sentences may be faulty or mechanical due to misuse, overuse or omission.\n• The use of reference and substitution may lack flexibility or clarity and result in some repetition or error.",
                comment:
                  "Bài viết sắp xếp thông tin và ý tưởng một cách mạch lạc và có một tiến trình tổng thể rõ ràng<br />" +
                  "Sử dụng các từ nối một cách hiệu quả, nhưng sự liên kết bên trong và/hoặc giữa các câu có thể bị lỗi hoặc máy móc hoá<br />" +
                  "Việc dùng từ tham chiếu và từ thay thế chưa linh hoạt hoặc chưa rõ ràng, dẫn đến lặp từ hoặc mắc lỗi",
                score: 6,
              },
              {
                eComment: "• Information and ideas are logically organised and there is a clear progression throughout the response. A few lapses may occur.\n• A range of cohesive devices including reference and substitution is used flexibly but with some inaccuracies or some over/under use.",
                comment:
                  "Bài viết sắp xếp thông tin và ý tưởng một cách hợp lý; có sự tiến bộ rõ ràng trong suốt bài, nhưng vẫn có thể có một vài thiếu sót về sự gắn kết<br />" +
                  "Bài viết sử dụng một loạt các từ nối tương đối linh hoạt tuy nhiên có thể có vài lỗi nhỏ trong cách dùng hoặc sắp xếp",
                score: 7,
              },
              {
                eComment: "• The message can be followed with ease.\n• Information and ideas are logically sequenced, and cohesion is well managed.\n• Occasional lapses in coherence or cohesion may occur.\n• Paragraphing is used sufficiently and appropriately.",
                comment:
                  "Bài viết trình bày các thông tin và ý tưởng một cách hợp lý<br />" +
                  "Việc sử dụng từ nối và phân đoạn phù hợp, mặc dù đôi khi có thể có những thiếu sót nhỏ",
                score: 8,
              },
              {
                eComment: "• The message can be followed effortlessly.\n• Cohesion is used in such a way that it very rarely attracts attention.\n• Any lapses in coherence or cohesion are minimal.\n• Paragraphing is skilfully managed.",
                comment:
                  "Các ý tưởng của bài viết được sắp xếp và liên kết một cách tự nhiên, rõ ràng và dễ theo dõi.<br />" +
                  "Phần chia đoạn và các từ nối được sử dụng một cách tinh tế, không làm phân tán sự chú ý của người đọc",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "lexicalResource",
        label: "Lexical Resource",
        items: [
          {
            key: "varietyOfVocabulary",
            label: "",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                eComment: "• Responses of 20 words or fewer are rated at Band 1.\n• No resource is apparent, except for a few isolated words.",
                comment:
                  "Bài viết của học viên dưới 20 từ được chấm ở Band 1<br />" +
                  "Không có vốn từ cần thiết để diễn đạt ý tưởng, chỉ vài từ đơn lẻ hoặc lỗi nặng về từ vựng",
                score: 1,
              },
              {
                eComment: "• The resource is extremely limited with few recognisable strings, apart from memorised phrases.\n• There is no apparent control of word formation and/or spelling.",
                comment:
                  "Bài viết sử dụng một lượng từ vựng rất hạn chế; về cơ bản chưa kiểm soát được các lỗi sai về cấu tạo từ và/hoặc chính tả",
                score: 2,
              },
              {
                eComment: "• The resource is inadequate (which may be due to the response being significantly underlength).\n• Possible over-dependence on input material or memorised language.\n• Control of word choice and/or spelling is very limited, and errors predominate. These errors may severely impede meaning.",
                comment:
                  "Bài viết chỉ sử dụng một phạm vi từ nhất định, phụ thuộc nhiều vào từ đã học thuộc<br />" +
                  "Một số lỗi trong bài viết có thể làm thay đổi về mặt ngữ nghĩa<br />" +
                  "Cách diễn đạt còn rất hạn chế với khả năng kiểm soát rất hạn chế về cấu tạo từ và/hoặc chính tả",
                score: 3,
              },
              {
                eComment: "• The resource is limited and inadequate for or unrelated to the task. Vocabulary is basic and may be used repetitively.\n• There may be inappropriate use of lexical chunks (e.g. memorised phrases, formulaic language and/or language from the input material).\n• Inappropriate word choice and/or errors in word formation and/or in spelling may impede meaning.",
                comment:
                  "Bài viết chỉ sử dụng từ vựng hạn chế, đơn giản, thường sử dụng lặp lại hoặc có thể không phù hợp với đề bài<br />" +
                  "Bài viết có thể dùng sai cụm từ<br />" +
                  "Các lỗi từ vựng có thể gây khó khăn trong việc hiểu",
                score: 4,
              },
              {
                eComment: "• The resource is limited but minimally adequate for the task.\n• Simple vocabulary may be used accurately but the range does not permit much variation in expression.\n•  There may be frequent lapses in the appropriacy of word choice, and a lack of flexibility is apparent in frequent simplifications and/or repetitions.\n•  Errors in spelling and/or word formation may be noticeable and may cause some difficulty for the reader.",
                comment:
                  "Bài viết chỉ sử dụng từ vựng hạn chế, nhưng các từ vựng này phù hợp với chủ đề<br />" +
                  "Bài viết có thể dùng từ vựng đơn giản khá chính xác nhưng ít đa dạng, cách diễn đạt lặp lại<br />" +
                  "Bài viết thường chọn từ chưa phù hợp, thiếu linh hoạt, hay lặp lại hoặc viết quá đơn giản<br />" +
                  "Lỗi từ vựng có thể ảnh hưởng đến khả năng hiểu nội dung",
                score: 5,
              },
              {
                eComment: "• The resource is generally adequate and appropriate for the task.\n• The meaning is generally clear in spite of a rather restricted range or a lack of precision in word choice.\n• If the writer is a risk-taker, there will be a wider range of vocabulary used but higher degrees of inaccuracy or inappropriacy.\n• There are some errors in spelling and/or word formation, but these do not impede communication.",
                comment:
                  "Bài viết sử dụng đủ lượng từ vựng cho chủ đề<br />" +
                  "Cố gắng sử dụng từ vựng ít phổ biến hơn nhưng có một số từ sử dụng thiếu sự linh hoạt và chính xác<br />" +
                  "Mắc một số lỗi chính tả và/hoặc cấu tạo từ, nhưng ảnh hưởng lớn đến nội dung",
                score: 6,
              },
              {
                eComment: "• The resource is sufficient to allow some flexibility and precision.\n• There is some ability to use less common and/or idiomatic items.\n• An awareness of style and collocation is evident, though inappropriacies occur.\n• There are only a few errors in spelling and/or word formation, and they do not detract from overall clarity.",
                comment:
                  "Bài viết sử dụng vốn từ vựng đủ rộng để diễn đạt ý tưởng một cách linh hoạt và chính xác<br />" +
                  "Sử dụng các mục từ vựng ít phổ biến hơn, nắm được về văn phong và collocation<br />" +
                  "Thỉnh thoảng có thể mắc lỗi trong việc lựa chọn từ, chính tả và/hoặc cấu tạo từ",
                score: 7,
              },
              {
                eComment: "• A wide resource is fluently and flexibly used to convey precise meanings within the scope of the task.\n• There is skilful use of uncommon and/or idiomatic items when appropriate, despite occasional inaccuracies in word choice and\ncollocation.\n• Occasional errors in spelling and/or word formation may occur, but have minimal impact on communication.",
                comment:
                  "Bài viết sử dụng vốn từ vựng phong phú, một cách trôi chảy và linh hoạt, truyền đạt ý nghĩa một cách chính xác<br />" +
                  "Học viên khéo léo sử dụng các từ vựng không phổ biến nhưng đôi khi có thể không chính xác trong việc lựa chọn từ và kết hợp từ phù hợp<br />" +
                  "Bài viết thỉnh thoảng mắc các lỗi hiếm gặp về chính tả và/hoặc cấu tạo từ",
                score: 8,
              },
              {
                eComment: "• Full flexibility and precise use are evident within the scope of the task.\n• A wide range of vocabulary is used accurately and appropriately with very natural and sophisticated control of lexical features.\n• Minor errors in spelling and word formation are extremely rare and have minimal impact on communication.",
                comment:
                  "Bài viết sử dụng một lượng từ vựng phong phú với độ chính xác và tự nhiên cao<br />" +
                  "Bài viết có các lỗi nhỏ về chính tả hoặc cấu trúc từ rất hiếm gặp và không ảnh hưởng đến nội dung",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "grammarAccuracy",
        label: "Grammatical Range & Accuracy",
        items: [
          {
            key: "grammarAccuracy",
            label: "",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                eComment: "• Responses of 20 words or fewer are rated at Band 1.\n• No rateable language is evident.",
                comment:
                  "Bài viết của học viên dưới 20 từ được chấm ở Band 1<br />" +
                  "Không có cấu trúc câu rõ ràng, nhiều lỗi ngữ pháp làm mất hoàn toàn ý nghĩa của bài viết",
                score: 1,
              },
              {
                eComment: "• There is little or no evidence of sentence forms (except in memorised phrases).",
                comment:
                  "Bài viết chưa sử dụng được các mẫu câu ngoại trừ trong các cụm từ được ghi nhớ",
                score: 2,
              },
              {
                eComment: "• Sentence forms are attempted, but errors in grammar and punctuation predominate (except in memorised phrases or those taken from the input material). This prevents most meaning from coming through.\n• Length may be insufficient to provide evidence of control of sentence forms.",
                comment:
                  "Học viên đã cố gắng đặt câu nhưng lỗi ngữ pháp và dấu câu chiếm còn nhiều và làm cho bài viết khó hiểu<br />" +
                  "Bài viết có thể quá ngắn nên chưa thể hiện được khả năng sử dụng và kiểm soát cấu trúc câu",
                score: 3,
              },
              {
                eComment: "• A very limited range of structures is used.\n• Subordinate clauses are rare and simple sentences predominate.\n• Some structures are produced accurately but grammatical errors are frequent and may impede meaning.\n• Punctuation is often faulty or inadequate.",
                comment:
                  "Bài viết chỉ sử dụng cấu trúc câu hạn chế và các câu phức hiếm khi chính xác<br />" +
                  "Một số cấu trúc được sử dụng chính xác nhưng vẫn còn tồn tại nhiều lỗi ngữ pháp ảnh hưởng đến nội dung<br />" +
                  "Bài viết sử dụng dấu câu thường sai hoặc chưa đầy đủ",
                score: 4,
              },
              {
                eComment: "• The range of structures is limited and rather repetitive.\n• Although complex sentences are attempted, they tend to be faulty, and the greatest accuracy is achieved on simple sentences.\n• Grammatical errors may be frequent and cause some difficulty for the reader.\n• Punctuation may be faulty.",
                comment:
                  "Bài viết chỉ sử dụng một số cấu trúc hạn chế<br />" +
                  "Học viên cố gắng đặt những câu phức tạp nhưng những câu này có xu hướng kém chính xác hơn những câu đơn giản<br />" +
                  "Bài viết có thể mắc lỗi ngữ pháp phổ biến và dấu câu có thể bị lỗi; lỗi có thể gây ra một số khó khăn trong việc hiểu nội dung",
                score: 5,
              },
              {
                eComment: "• A mix of simple and complex sentence forms is used but flexibility is limited.\n• Examples of more complex structures are not marked by the same level of accuracy as in simple structures.\n• Errors in grammar and punctuation occur, but rarely impede communication",
                comment:
                  "Bài viết sử dụng kết hợp các câu đơn giản và câu phức một cách hợp lý, nhưng có thể hạn chế trong sự linh hoạt và độ chính xác<br />" +
                  "Lỗi ngữ pháp và dấu câu có thể thường xuyên hơn nhưng hiếm làm cản trở nội dung",
                score: 6,
              },
              {
                eComment: "• A variety of complex structures is used with some flexibility and accuracy.\n• Grammar and punctuation are generally well controlled, and error-free sentences are frequent.\n• A few errors in grammar may persist, but these do not impede communication.",
                comment:
                  "Bài viết sử dụng nhiều loại câu phức với mức độ linh hoạt và chính xác nhất định<br />" +
                  "Ngữ pháp và dấu câu nhìn chung được kiểm soát tốt, nhiều câu hoàn toàn không có lỗi<br />" +
                  "Một vài lỗi nhỏ có thể xuất hiện nhưng không ảnh hưởng lớn đến nội dung",
                score: 7,
              },
              {
                eComment: "• A wide range of structures within the scope of the task is flexibly and accurately used.\n• The majority of sentences are error-free, and punctuation is well managed.\n• Occasional, non-systematic errors and inappropriacies occur, but have minimal impact on communication.",
                comment:
                  "Học viên sử dụng phạm vi cấu trúc ngữ pháp rộng, các câu phức được sử dụng chính xác và tự nhiên<br />" +
                  "Phần lớn các câu không có lỗi, dấu câu được dùng hợp lý<br />" +
                  "Một vài lỗi nhỏ có thể xuất hiện nhưng không gây khó khăn cho người đọc",
                score: 8,
              },
              {
                eComment: "• A wide range of structures within the scope of the task is used with full flexibility and control.\n• Punctuation and grammar are used appropriately throughout.\n• Minor errors are extremely rare and have minimal impact on communication",
                comment:
                  "Học viên sử dụng linh hoạt và kiểm soát hoàn toàn các cấu trúc ngữ pháp phức tạp và dấu câu<br />" +
                  "Ngữ pháp và dấu câu được dùng chuẩn xác xuyên suốt bài viết<br />" +
                  "Các lỗi ngữ pháp hiếm khi xuất hiện và không làm ảnh hưởng đến nội dung",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
    ],
  },
  IEWriting2Entrance: {
    label: "IE High Writing 2 Entrance",
    items: [
      {
        key: "taskResponse",
        label: "Task Response",
        items: [
          {
            key: "followRequirementsOfProblem",
            label: "",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                eComment: "• Responses of 20 words or fewer are rated at Band 1.\n• The content is wholly unrelated to the prompt.\n• Any copied rubric must be discounted.",
                comment:
                  "Bài viết của học viên dưới 20 từ được chấm ở Band 1<br />" +
                  "Nội dung bài viết hoàn toàn không liên quan đến đề bài<br />" +
                  "Bất kỳ phần sao chép nào từ đề thì bài viết phải bị loại bỏ",
                score: 1,
              },
              {
                eComment: "• The content is barely related to the prompt.\n• No position can be identified.\n• There may be glimpses of one or two ideas without development.",
                comment:
                  "Bài viết hầu như không đáp ứng được yêu cầu của đề bài<br />" +
                  "Bài viết không thể hiện được quan điểm<br />" +
                  "Có cố gắng trình bày một hoặc hai ý tưởng nhưng không biết cách phát triển những ý tưởng đó",
                score: 2,
              },
              {
                eComment: "• No part of the prompt is adequately addressed, or the prompt has been misunderstood.\n• No relevant position can be identified, and/or there is little direct response to the question/s.\n• There are few ideas, and these may be irrelevant or insufficiently developed.",
                comment:
                  "Bài viết không thể hiện rõ ràng quan điểm<br />" +
                  "Trình bày rất ít ý tưởng, phần lớn trong số đó không được phát triển hoặc không liên quan đến chủ đề",
                score: 3,
              },
              {
                eComment: "• The prompt is tackled in a minimal way, or the answer is tangential, possibly due to some misunderstanding of the prompt. The format may be inappropriate.\n• A position is discernible, but the reader has to read carefully to find it.\n• Main ideas are difficult to identify and such ideas that are identifiable may lack relevance, clarity and/or support.\n• Large parts of the response may be repetitive.",
                comment:
                  "Bài viết chỉ đáp ứng yêu cầu của đề bài một cách tối thiểu hoặc bị lạc đề/xa đề; định dạng bài viết có thể không phù hợp<br />" +
                  "Bài viết có trình bày quan điểm nhưng không rõ ràng<br />" +
                  "Bài viết trình bày được một số ý chính nhưng không rõ ràng, khó xác định và có thể lặp đi lặp lại, không liên quan hoặc không được hỗ trợ tốt",
                score: 4,
              },
              {
                eComment: "• The main parts of the prompt are incompletely addressed. The format may be inappropriate in places.\n• The writer expresses a position, but the development is not always clear.\n• Some main ideas are put forward, but they are limited and are not sufficiently developed and/or there may be irrelevant detail.\n• There may be some repetition.",
                comment:
                  "Bài viết chỉ đáp ứng một phần yêu cầu đề bài; định dạng bài viết có thể không phù hợp ở một vài chỗ<br />" +
                  "Bài viết thể hiện được quan điểm của người viết nhưng cách phát triển bài không phải lúc nào cũng rõ ràng và có thể không có rút ra được kết luận.<br />" +
                  "Bài viết trình bày một số ý chính nhưng rất hạn chế và không phát triển đầy đủ; có thể chứa những chi tiết không liên quan",
                score: 5,
              },
              {
                eComment: "• The main parts of the prompt are addressed (though some may be more fully covered than others). An appropriate format is used.\n• A position is presented that is directly relevant to the prompt, although the conclusions drawn may be unclear, unjustified or repetitive.\n• Main ideas are relevant, but some may be insufficiently developed or may lack clarity, while some supporting arguments and evidence may be less relevant or inadequate.",
                comment:
                  "Bài viết đáp ứng tất cả các yêu cầu của đề bài mặc dù một số phần có thể được triển khai đầy đủ hơn những phần khác<br />" +
                  "Bài viết trình bày quan điểm liên quan đến chủ đề dù các kết luận có thể không rõ ràng hoặc lặp đi lặp lại<br />" +
                  "Bài viết trình bày các ý chính liên quan nhưng một số có thể không được triển khai đủ sâu/không rõ ràng",
                score: 6,
              },
              {
                eComment: "• The main parts of the prompt are appropriately addressed.\n• A clear and developed position is presented.\n• Main ideas are extended and supported but there may be a tendency to over-generalise or there may be a lack of focus and precision in supporting ideas/material.",
                comment:
                  "Bài viết đáp ứng tất cả các yêu cầu của đề bài<br />" +
                  "Bài viết thể hiện quan điểm rõ ràng trong suốt bài viết<br />" +
                  "Bài viết trình bày, mở rộng và hỗ trợ các ý chính, nhưng có xu hướng mắc lỗi khái quát hóa quá mức và/hoặc các ý tưởng hỗ trợ có thể thiếu tập trung",
                score: 7,
              },
              {
                eComment: "• The prompt is appropriately and sufficiently addressed.\n• A clear and well-developed position is presented in response to the question/s.\n• Ideas are relevant, well extended and supported.\n• There may be occasional omissions or lapses in content.",
                comment:
                  "Bài viết đáp ứng vừa đủ các yêu cầu của đề bài<br />" +
                  "Trình bày quan điểm rõ ràng, phát triển tốt và trực tiếp trả lời câu hỏi trong suốt bài làm<br />" +
                  "Trình bày, mở rộng và có hệ thống ý tưởng liên quan, mở rộng và làm rõ chủ đề<br />" +
                  "Bài viết có thể có một vài thiếu sót nhỏ trong nội dung",
                score: 8,
              },
              {
                eComment: "• The prompt is appropriately addressed and explored in depth.\n• A clear and fully developed position is presented which directly answers the question/s.\n• Ideas are relevant, fully extended and well supported.\n• Any lapses in content or support are extremely rare.",
                comment:
                  "Bài viết đáp ứng được tất cả yêu cầu của đề bài<br />" +
                  "Bài viết trình bày rõ ràng quan điểm của người viết về chủ đề bằng hệ thống ý tưởng liên quan, mở rộng và hỗ trợ làm rõ chủ đề<br />" +
                  "Bài viết hầu như không có sai sót trong nội dung hoặc lập luận",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "contentCoherence",
        label: "Coherence & Cohesion",
        items: [
          {
            key: "contentCoherence",
            label: "",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                eComment: "• Responses of 20 words or fewer are rated at Band 1.\n• The writing fails to communicate any message and appears to be by a virtual non-writer.",
                comment:
                  "Bài viết dưới 20 từ được xếp ở Band 1<br />" +
                  "Bài viết không thể hiện được ý tưởng nào",
                score: 1,
              },
              {
                eComment: "• There is little relevant message, or the entire response may\nbe off-topic.\n• There is little evidence of control of organisational features.",
                comment:
                  "Bài viết hầu như không sắp xếp được ý tưởng cho bài viết hoặc toàn bộ nội dung có thể lạc đề",
                score: 2,
              },
              {
                eComment: "• There is no apparent logical organisation. Ideas are discernible but difficult to relate to each other.\n• There is minimal use of sequencers or cohesive devices. Those used do not necessarily indicate a logical relationship between ideas.\n• There is difficulty in identifying referencing.\n• Any attempts at paragraphing are unhelpful.",
                comment:
                  "Bài viết chưa trình bày được ý tưởng một cách logic<br />" +
                  "Học viên có thể sử dụng một số lượng rất hạn chế các từ nối. Tuy nhiên các từ nối có thể chưa liên kết được mối quan hệ logic giữa các ý tưởng",
                score: 3,
              },
              {
                eComment: "• Information and ideas are evident but not arranged coherently and there is no clear progression within the response.\n• Relationships between ideas can be unclear and/or inadequately marked. There is some use of basic cohesive devices, which may be inaccurate or repetitive.\n• There is inaccurate use or a lack of substitution or referencing.\n• There may be no paragraphing and/or no clear main topic within paragraphs.",
                comment:
                  "Bài viết trình bày thông tin và ý tưởng nhưng chưa được sắp xếp một cách mạch lạc và không thể hiện được luận điểm trung tâm của bài một cách xuyên suốt<br />" +
                  "Sử dụng các công cụ liên kết đơn giản nhưng có thể không chính xác hoặc bị lặp từ<br />" +
                  "Các thông tin và ý tưởng có thể không viết được dưới dạng đoạn văn hoàn chỉnh",
                score: 4,
              },
              {
                eComment: "• Organisation is evident but is not wholly logical and there may be a lack of overall progression. Nevertheless, there is a sense of underlying coherence to the response.\n• The relationship of ideas can be followed but the sentences are not fluently linked to each other.\n• There may be limited/overuse of cohesive devices with some inaccuracy.\n• The writing may be repetitive due to inadequate and/or inaccurate use of reference and substitution.\n• Paragraphing may be inadequate or missing.",
                comment:
                  "Bài viết trình bày thông tin với một số cách sắp xếp ý tưởng nhưng có thể thiếu diễn tiến tổng thể<br />" +
                  "Các từ nối chưa đầy đủ, chưa chính xác hoặc lạm dụng.<br />" +
                  "Có thể lặp đi lặp lại vì thiếu tham chiếu và thay thế<br />" +
                  "Có thể không viết thành đoạn văn, hoặc đoạn văn có thể không đầy đủ",
                score: 5,
              },
              {
                eComment: "• Information and ideas are generally arranged coherently and there is a clear overall progression.\n• Cohesive devices are used to some good effect but cohesion within and/or between sentences may be faulty or mechanical due to misuse, overuse or omission.\n• The use of reference and substitution may lack flexibility or clarity and result in some repetition or error.\n• Paragraphing may not always be logical and/or the central topic may not always be clear.",
                comment:
                  "Bài viết sắp xếp thông tin và ý tưởng một cách mạch lạc và có một diễn tiến tổng thể rõ ràng<br />" +
                  "Sử dụng các từ nối một cách hiệu quả, nhưng sự liên kết bên trong và/hoặc giữa các câu có thể bị lỗi hoặc máy móc hoá<br />" +
                  "Bài viết chưa có sự ổn định trong việc dùng phép dẫn chiếu một cách rõ ràng và hợp lý<br />" +
                  "Việc phân chia đoạn văn có thể chưa luôn hợp lý và/hoặc ý chính của đoạn có thể chưa được trình bày rõ ràng",
                score: 6,
              },
              {
                eComment: "• Information and ideas are logically organised, and there is a clear progression throughout the response. (A few lapses may occur, but these are minor.)\n• A range of cohesive devices including reference and substitution is used flexibly but with some inaccuracies or some over/under use.\n• Paragraphing is generally used effectively to support overall coherence, and the sequencing of ideas within a paragraph is generally logical.",
                comment:
                  "Bài viết tổ chức thông tin và ý tưởng một cách logic; bài văn thể hiện được luận điểm trung tâm của bài một cách xuyên suốt (từ mở bài đến kết bài)<br />" +
                  "Sử dụng một loạt các công cụ liên kết một cách phù hợp mặc dù có đôi chỗ chưa tận dụng hoặc lạm dụng<br />" +
                  "Trong mỗi đoạn văn trình bày rõ một chủ đề trọng tâm",
                score: 7,
              },
              {
                eComment: "• The message can be followed with ease.\n• Information and ideas are logically sequenced, and cohesion is well managed.\n• Occasional lapses in coherence and cohesion may occur.\n• Paragraphing is used sufficiently and appropriately.",
                comment:
                  "Bài viết sắp xếp trình tự thông tin và ý tưởng một cách logic, khả năng liên kết được kiểm soát tốt<br />" +
                  "Đôi khi bài viết vẫn có thể xuất hiện sai sót nhỏ về tính mạch lạc và liên kết<br />" +
                  "Bài viết chia đoạn văn một cách hợp lý",
                score: 8,
              },
              {
                eComment: "• The message can be followed effortlessly.\n• Cohesion is used in such a way that it very rarely attracts attention.\n• Any lapses in coherence or cohesion are minimal.\n• Paragraphing is skilfully managed.",
                comment:
                  "Bài viết sử dụng các công cụ liên kết một cách mượt mà và không gây ra sự chú ý<br />" +
                  "Bất kỳ sai sót nào của bài viết về mạch lạc hoặc liên kết đều ở mức tối thiểu<br />" +
                  "Bài viết chia đoạn văn một cách khéo léo",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "lexicalResource",
        label: "Lexical Resource",
        items: [
          {
            key: "varietyOfVocabulary",
            label: "",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                eComment: "• Responses of 20 words or fewer are rated at Band 1.\n• No resource is apparent, except for a few isolated words.",
                comment:
                  "Bài viết dưới 20 từ được xếp ở Band 1<br />" +
                  "Bài viết chỉ có thể sử dụng một vài từ riêng lẻ",
                score: 1,
              },
              {
                eComment: "• The resource is extremely limited with few recognisable strings, apart from memorised phrases.\n• There is no apparent control of word formation and/or spelling.",
                comment:
                  "Bài viết sử dụng một lượng từ vựng hạn chế<br />" +
                  "Bài viết không kiểm soát được các lỗi sai về cấu tạo từ và/hoặc chính tả",
                score: 2,
              },
              {
                eComment: "• The resource is inadequate (which may be due to the response being significantly underlength). Possible over-dependence on input material or memorised language.\n• Control of word choice and/or spelling is very limited, and errors predominate. These errors may severely impede meaning.",
                comment:
                  "Bài viết chỉ sử dụng rất ít từ vựng. Có thể quá phụ thuộc vào tài liệu hoặc ngôn ngữ học thuộc.<br />" +
                  "Khả năng chọn từ và/hoặc chính tả rất hạn chế, lỗi sai chiếm đa số và có thể làm sai nghĩa các ý",
                score: 3,
              },
              {
                eComment: "• The resource is limited and inadequate for or unrelated to the task. Vocabulary is basic and may be used repetitively.\n• There may be inappropriate use of lexical chunks (e.g. memorised phrases, formulaic language and/or language from the input material).\n• Inappropriate word choice and/or errors in word formation and/or in spelling may impede meaning.",
                comment:
                  "Vốn từ hạn chế và không phù hợp hoặc không liên quan đến đề bài.<br />" +
                  "Bài viết sử dụng từ vựng ở mức cơ bản và những từ này có thể được sử dụng lặp đi lặp lại hoặc có thể không phù hợp với yêu cầu đề bài<br />" +
                  "Việc chọn từ không chính xác và/hoặc lỗi cấu tạo từ, chính tả có thể gây khó hiểu cho người đọc",
                score: 4,
              },
              {
                eComment: "• The resource is limited but minimally adequate for the task.\n• Simple vocabulary may be used accurately but the range does not permit much variation in expression.\n• There may be frequent lapses in the appropriacy of word choice and a lack of flexibility is apparent in frequent simplifications and/or repetitions.\n• Errors in spelling and/or word formation may be noticeable and may cause some difficulty for the reader.",
                comment:
                  "Bài viết sử dụng một lượng từ vựng hạn chế nhưng đủ để đáp ứng yêu cầu đề bài<br />" +
                  "Bài viết có thể dùng đúng một số từ vựng đơn giản nhưng không đa dạng, ít biến đổi cách diễn đạt.<br />" +
                  "Bài viết thường xuyên dùng từ không phù hợp, thể hiện sự thiếu linh hoạt qua việc đơn giản hóa/lặp lại nhiều.<br />" +
                  "Bài viết có thể mắc các lỗi chính tả và / hoặc trong cách cấu tạo từ gây ra một số khó khăn cho người đọc",
                score: 5,
              },
              {
                eComment: "• The resource is generally adequate and appropriate for the task.\n• The meaning is generally clear in spite of a rather restricted range or a lack of precision in word choice.\n• If the writer is a risk-taker, there will be a wider range of vocabulary used but higher degrees of inaccuracy or inappropriacy.\n• There are some errors in spelling and/or word formation, but these do not impede communication.",
                comment:
                  "Bài viết sử dụng lượng từ vựng vừa đủ và phù hợp để đáp ứng yêu cầu đề bài<br />" +
                  "Học viên cố gắng sử dụng những từ vựng ít phổ biến hơn nhưng không có độ chính xác.<br />" +
                  "Học viên có thể dùng từ đa dạng hơn nhưng một số chỗ có thể dễ sai hoặc không phù hợp.<br />" +
                  "Bài viết vẫn mắc một số lỗi về chính tả và /hoặc về cấu tạo từ, nhưng chúng không gây cản trở",
                score: 6,
              },
              {
                eComment: "• The resource is sufficient to allow some flexibility and precision.\n• There is some ability to use less common and/or idiomatic items.\n• An awareness of style and collocation is evident, though inappropriacies occur.\n• There are only a few errors in spelling and/or word formation and they do not detract from overall clarity.",
                comment:
                  "Bài viết sử dụng lượng từ vựng để tạo sự linh hoạt và chính xác<br />" +
                  "Học viên có ý thức về phong cách và sự kết hợp từ, dù đôi khi chưa phù hợp.<br />" +
                  "Bài viết sử dụng các từ vựng ít phổ biến và/hoặc thành ngữ hơn nhưng đôi khi có thể mắc lỗi trong việc lựa chọn từ ngữ, chính tả và / hoặc cấu tạo từ",
                score: 7,
              },
              {
                eComment: "• A wide resource is fluently and flexibly used to convey precise meanings.\n• There is skilful use of uncommon and/or idiomatic items when appropriate, despite occasional inaccuracies in word choice and collocation.\n• Occasional errors in spelling and/or word formation may occur, but have minimal impact on communication.",
                comment:
                  "Bài viết sử dụng lượng từ vựng lớn<br />" +
                  "Bài viết sử dụng các từ vựng ít phổ biến và/hoặc thành ngữ, nhưng đôi khi có thể mắc lỗi trong việc lựa chọn từ ngữ hoặc sử dụng collocation<br />" +
                  "Bài viết mắc một số lỗi về chính tả hoặc cấu tạo từ",
                score: 8,
              },
              {
                eComment: "• Full flexibility and precise use are widely evident.\n• A wide range of vocabulary is used accurately and appropriately with very natural and sophisticated control of lexical features.\n• Minor errors in spelling and word formation are extremely rare and have minimal impact on communication.",
                comment:
                  "Sử dụng nhiều loại từ vựng một cách tự nhiên và linh hoạt để truyền đạt ý nghĩa chính xác và biết cách sử dụng các từ vựng phức tạp<br />" +
                  "Bài viết hiếm mắc lỗi chính tả/cấu tạo từ và gần như không ảnh hưởng đến giao tiếp.",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
      {
        key: "grammarAccuracy",
        label: "Grammatical Range & Accuracy",
        items: [
          {
            key: "grammarAccuracy",
            label: "",
            comment_auto: "",
            criterion_score: "",
            items: [
              {
                eComment: "• Responses of 20 words or fewer are rated at Band 1.\nNo rateable language is evident.",
                comment:
                  "Bài viết dưới 20 từ được xếp ở Band 1<br />" +
                  "Bài viết hoàn toàn không thể viết thành câu",
                score: 1,
              },
              {
                eComment: "• There is little or no evidence of sentence forms (except in memorised phrases).",
                comment:
                  "Bài viết không thể viết thành câu ngoại trừ những câu đã học thuộc lòng từ trước",
                score: 2,
              },
              {
                eComment: "• Sentence forms are attempted, but errors in grammar and punctuation predominate (except in memorised phrases or those taken from the input material). This prevents most meaning from coming through.\n• Length may be insufficient to provide evidence of control of sentence forms.",
                comment:
                  "Học viên có cố gắng viết câu hoàn chỉnh, nhưng lỗi sai ngữ pháp và dấu câu khiến thông điệp bị bóp méo (ngoại trừ cụm từ học thuộc hoặc lấy từ đề bài)",
                score: 3,
              },
              {
                eComment: "• A very limited range of structures is used.\n• Subordinate clauses are rare and simple sentences predominate.\n• Some structures are produced accurately but grammatical errors are frequent and may impede meaning.\n• Punctuation is often faulty or inadequate.",
                comment:
                  "Bài viết chỉ sử dụng được một lượng rất hạn chế các cấu trúc và hiếm khi sử dụng được mệnh đề phụ thuộc<br />" +
                  "Một số cấu trúc được sử dụng chính xác tuy nhiên thường xuyên sai ngữ pháp và dấu câu",
                score: 4,
              },
              {
                eComment: "• The range of structures is limited and rather repetitive.\n• Although complex sentences are attempted, they tend to be faulty, and the greatest accuracy is achieved on simple sentences.\n• Grammatical errors may be frequent and cause some difficulty for the reader.\n• Punctuation may be faulty.",
                comment:
                  "Bài viết chỉ sử dụng một lượng hạn chế các cấu trúc<br />" +
                  "Học viên có cố gắng đặt những câu phức tạp nhưng những câu này sẽ không chính xác bằng các cấu trúc câu đơn<br />" +
                  "Bài viết thường xuyên mắc lỗi ngữ pháp và dấu câu có thể bị lỗi; lỗi có thể gây ra một số khó khăn cho người đọc",
                score: 5,
              },
              {
                eComment: "• A mix of simple and complex sentence forms is used but flexibility is limited.\n• Examples of more complex structures are not marked by the same level of accuracy as in simple structures.\n• Errors in grammar and punctuation occur, but rarely impede communication.",
                comment:
                  "Bài viết kết hợp sử dụng cấu trúc đơn giản và phức tạp<br />" +
                  "Mắc một số lỗi ngữ pháp và dấu câu nhưng không ảnh hưởng tới truyền đạt thông tin",
                score: 6,
              },
              {
                eComment: "• A variety of complex structures is used with some flexibility and accuracy.\n• Grammar and punctuation are generally well controlled, and error-free sentences are frequent.\n• A few errors in grammar may persist, but these do not impede communication.",
                comment:
                  "Bài viết sử dụng nhiều cấu trúc phức tạp<br />" +
                  "Phần lớn các câu trong bài đều không mắc lỗi<br />" +
                  "Bài viết sử dụng đúng ngữ pháp và dấu câu nhưng có thể mắc một vài lỗi",
                score: 7,
              },
              {
                eComment: "• A wide range of structures is flexibly and accurately used.\n• The majority of sentences are error-free, and punctuation is well managed.\n• Occasional, non-systematic errors and inappropriacies occur, but have minimal impact on communication.",
                comment:
                  "Bài viết sử dụng lượng lớn cấu trúc<br />" +
                  "Hầu hết các câu văn trong bài viết đều không mắc lỗi<br />" +
                  "Bài viết rất ít khi mắc lỗi hoặc sử dụng cấu trúc không phù hợp",
                score: 8,
              },
              {
                eComment: "• A wide range of structures is used with full flexibility and control.\n• Punctuation and grammar are used appropriately throughout.\n• Minor errors are extremely rare and have minimal impact on communication.",
                comment:
                  "Bài viết sử dụng lượng lớn cấu trúc một cách tự nhiên và chính xác<br />" +
                  "Bài viết sử dụng dấu câu và ngữ pháp một cách phù hợp và chính xác trong toàn bài<br />" +
                  "Bài viết hiếm mắc lỗi ngữ pháp hầu như không ảnh hưởng đến khả năng truyền đạt",
                score: 9,
              },
            ],
          },
        ],
        comment_detail: "",
      },
    ],
  },
};


// IELTS
export const FOUNDATIONS_1VS6 = 1247
export const FOUNDATIONS_1VS1 = 1466
export const BASIC = 1621
export const PRE = 1622
export const IELTS3545 = 1623
export const IELTS4555 = 1624
export const IELTS5565 = 1625

export const BASIC_IELTS_ONLINE= 1630
export const PRE_IELTS_ONLINE= 1631
export const IELTS_3_5_4_5_ONLINE= 1632
export const IELTS_4_5_5_5_ONLINE= 1633
export const IELTS_5_5_6_5_ONLINE= 1634
export const IELTS_6_5_7_5_ONLINE= 1635
export const IELTS_PRACTICES_1626 = 1626
export const IELTS_PRACTICES_1629 = 1629
export const IELTS_65_75_ELITE = 1628
export const IELTS_45_55_1vs1 = 1467

// ECOACH
export const ECOACH_BASIC_TOEIC_ELITE= 1705;
export const ECOACH_PRE_TOEIC_ELITE= 1706;
export const ECOACH_3_5_4_5_ELITE= 1707;
export const ECOACH_4_5_5_5_ELITE= 1708;
export const ECOACH_5_5_6_5_ELITE= 1629;
export const TEST_EC_PRE_LIB= 1666

//CLASS UP
export const CLASS_UP_IELTS_55_65 = 1665
export const CLASS_UP_IELTS_45_55 = 1664
export const CLASS_UP_IELTS_35_45 = 1663
export const CLASS_UP_PRE_IELTS = 1662
export const CLASS_UP_BASIC = 1661
export const CLASS_UP_IELTS_55_65_1vs1 = 1660
export const CLASS_UP_IELTS_45_55_1vs1 = 1659
export const CLASS_UP_IELTS_35_45_1vs1 = 1658
export const CLASS_UP_PRE_IELTS_1vs1 = 1657
export const CLASS_UP_BASIC_1vs1 = 1656

export const SPEAKING = 1
export const WRITING = 2
export const LISTENING = 3
export const READING = 4

export const TYPE_WRITING_TEXT = 0
export const TYPE_WRITING_LINK = 1

export const BASIC_IELTS_ELITE = 1694
export const PRE_IELTS_ELITE = 1695
